<template>
  <div class="default-main ba-table-box">
    <!-- 表格顶部菜单 -->
    <buttons :buttons="['save', 'back', 'clear']"
             :access="['', '', '']" @btnClick="btnClick"

    ></buttons>

    <!-- 新建编辑 -->
    <formData ref="formData" :form="formData.form" :data="formData.data" :rules="formData.rules"
              style="margin-top: 20px"></formData>

    <!-- 窗口 -->
    <dialogWin ref="dialogWin" :center="true" width="900"></dialogWin>
    <!-- 支付弹窗   -->
    <scanBox
        ref="scanBox"
        :visible="showBox"
        :status="status"
        :countdown-seconds="60"
        @close="handleClose"
        @scanned="handleScanned"
        @poll="handlePoll"
        @timeout="handleTimeout"
        @pay="handlePay"
    />
    <!--  美团/抖音验券弹窗  -->
    <yanQuanScanBox
        ref="yanQuanScanBox"
        :config="yanQuanConfig"
        @update:visible="yanQuanConfig.visible = false"
        @scanSuccess="onYanQuanScanSuccess"
        @scanCheckCode="onYanQuanScanCheckCode"
        @scanFinalSubmit="onYanQuanScanFinalSubmit"
    />
  </div>
</template>

<script>
import buttons from '@/components/buttons.vue'
import formData from '@/components/formData.vue'
import dialogWin from '@/components/dialogWin.vue'
import scanBox from '@/components/scanBox.vue'
import yanQuanScanBox from '@/components/yanQuanScanBox.vue'
import {ElButton, ElCheckbox, ElCheckboxGroup, ElInput, ElLoading, ElMessage, ElMessageBox} from 'element-plus'
import {h} from 'vue'
import {
  enqueueYanQuanLog,
  scheduleYanQuanLogFlush,
  setYanQuanLogBusinessBusy
} from '@/utils/yanQuanLogQueue'
import {enqueueYanQuanBindRemedy} from '@/utils/yanQuanBindQueue'

let isInit = false;


export default {
  name: "themeOrderAdd",
  components: {
    buttons,
    formData,
    dialogWin,
    scanBox,
    yanQuanScanBox,
  },
  data() {
    return {
      showBox: false,
      status: "", // F | S | P
      isClosePay: false,//是否可以关闭支付弹窗

      //region 美团/抖音扫码验券数据
      yanQuanConfig: {
        visible: false,
        label: '',
        type: '',
        status: 'waiting',//  waiting | S
        details: '',//二阶段商品名称
        value: 1,//输入框值
        verifyCodeArr: [],
        payAmount: 0,//收款金额
        peopleNum: '',//人数
      },
      yanQuanChecking: false,
      yanQuanFlowId: '',
      yanQuanBusinessBusy: false,
      //endregion
      shopStaffList: [],           //店铺员工集合
      shopDiffPriceNoticeList: [],  //差额说明数组
      checkedTypes: [],
      orderPriceDiffNoticesInput: '',//差额说明弹窗input
      shopDiffPriceNoticeType: '',   //是否开启了差额说明提示
      currTheme: {},               //当前选择的主题
      sourRouter: "themeOrder",   //来源路由
      columnCount: 4,             //需要合并的前几列
      copyOrderPlayerList: null,   //复制的拼场信息
      payRow: {}, //汇支付 支付的row

      //region 新建编辑数据
      formData: {
        form: [
          {
            label: "主题名称",
            prop: 'themeName',
            type: 'radio',
            width: 1500,
            isLine: true,
            sourceList: [],
            lineWidth: 90,
            sourceProp: {text: 'themeName', value: 'id'},
            change: (e, item, index) => {
              if (this.formData.data.orderCreateTime) {
                this.themeRadioChange(e);
              }
            },
          },
          {
            label: "下单日期", prop: 'orderCreateTime', type: 'date', dateType: 'date',
            change: (e, item, index) => {
              if (this.formData.data.themeName) {
                this.themeRadioChange(this.formData.data.themeName);
              }
            },
          },
          {
            label: "选择场次",
            prop: 'sessionTime',
            type: 'radio',
            width: 1500,
            isLine: false,
            sourceList: [],
            lineWidth: 90,
            sourceProp: {text: 'sessionTimeText', value: 'sessionTime'},
            change: (e, item, index) => {
              let themeSessionList = this.$tools.getIndex(this.formData.form, 'sessionTime').sourceList;
              for (let i = 0; i < themeSessionList.length; i++) {
                // 先恢复默认颜色
                themeSessionList[i].style.borderColor = themeSessionList[i].originBorderColor;
                // 再给当前选中的设为黑色
                if (themeSessionList[i].sessionTime === e) {
                  if (themeSessionList[i].price) {
                    this.formData.data.themePrice = themeSessionList[i].price;
                    this.setPlayerAndPrice();
                    //计算收款金额
                    this.handlePayAmountByRow()
                  }
                  themeSessionList[i].style.borderColor = '#409eff';
                }
              }
            }
          },
          {label: "主题价格", prop: 'themePrice', type: 'text', disabled: true},
          {label: "订单备注", prop: 'note', type: 'textarea', width: 930, lineWidth: 90},
          //region 拼场信息
          {label: "拼场信息", prop: 'title', type: 'title'},
          {
            prop: 'button',
            type: 'button',
            // buttons: ['diy', 'diy1','diy2','diy3', 'diy5'],
            buttons: ['diy', 'diy6', 'diy7', 'diy8'],
            diy: {text: '新增', type: 'primary', icon: 'Plus',},
            // diy1: {text: '转场', type: 'primary', icon: 'DocumentCopy'},
            // diy5: {text: '汇付退款', type: 'primary', svg: 'pay', show: false},
            diy6: {text: '美团验券', type: 'primary', icon: 'Cellphone', show: true},
            diy7: {text: '抖音验券', type: 'primary', icon: 'Cellphone', show: true},
            diy8: {text: '优惠券验券', type: 'primary', icon: 'Cellphone', show: true},
            btnClick: res => {
              if (!this.formData.data.themeName) {
                this.$message.warning(`请选择主题!`);
                return false
              }
              if (!this.formData.data.sessionTime) {
                this.$message.warning(`请选择场次时间!`);
                return false
              }
              if (!this.validatePay()) return false

              if (res == 'diy') {
                //如果拼场信息中有一笔 汇付收款方式并且是未支付状态 禁止新增拼场
                this.addTableRow(0);
              } else if (res == 'diy1') {
                this.copyOrderPlayer();

              } else if (res == 'diy5') {
                //打开退款弹窗
              } else if (res == 'diy6' || res == 'diy7' || res == 'diy8') {
                let labelMap = {
                  'diy6': {
                    label: '美团验券',
                    type: 'meituan',
                  },
                  'diy7': {
                    label: '抖音验券',
                    type: 'douyin',
                  },
                  'diy8': {
                    label: '优惠券验券',
                    type: 'coupon',
                  }
                }


                if (!this.validateParams(this.buildParams())) return false
                this.yanQuanConfig.visible = true
                this.yanQuanConfig.label = labelMap[res].label
                this.yanQuanConfig.type = labelMap[res].type
                //1阶段
                this.$refs.yanQuanScanBox.goStage(1)
                this.yanQuanConfig.status = 'waiting'
              }
            }
          },
          {
            prop: 'orderPlayerList', type: 'table',
            tableData: {
              summary: true,
              column: [
                {
                  label: "玩家人数",
                  prop: 'playerNum',
                  type: 'inputDel',
                  isValid: 'integer',
                  max: 4,
                  show: true,
                  width: 80,
                  sum: true,
                  // input: (e, index) => {
                  //   this.setPlayCounts(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data[index]);
                  //   this.setPlayerAndPrice();
                  // },
                  blur: (e, index) => {
                    let orderPlayerItem = this.$tools.getIndex(
                        this.formData.form,
                        "orderPlayerList"
                    ).tableData.data[index];

                    //会员卡操作
                    if (orderPlayerItem.payMode === 17) {
                      if (orderPlayerItem.playerNum == 0) {
                        this.$message.warning("请输入有效的会员卡玩家人数");
                        orderPlayerItem.playerNum = "";
                        return;
                      }

                      // 判断是编辑还是新建
                      const isEdit = orderPlayerItem.payModedisabled === true;
                      // 编辑时上限为 MaximumUsageCount，新建时上限为 balance
                      const maxLimit = isEdit
                          ? orderPlayerItem.MaximumUsageCount
                          : orderPlayerItem.cardWallet.balance;

                      if (orderPlayerItem.playerNum > maxLimit) {
                        this.$message.warning("人数超过余额可抵扣额度，请重新输入");
                        orderPlayerItem.playerNum = "";
                        orderPlayerItem.payAmount = ''
                        orderPlayerItem.payCoins = ''
                        return;
                      }
                    }
                    this.setPlayCounts(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data[index]);
                    //计算应收
                    this.setPlayerAndPrice();
                    // 计算实收
                    // this.setTotalPayAmount();

                    //计算收款金额
                    // this.handlePayAmountByRow()
                  },
                  click: (res, row) => {

                    // 删除拼场行
                    let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;

                    // 先检查这一组是否有 payMode=19 且已支付的记录
                    const hasPaidCard = orderPlayerList.some(
                        (p) => p.rowId === row.rowId && p.payMode === 20 && p.bspayId
                    );
                    if (hasPaidCard) {
                      this.$message.warning("已有支付的汇支付不能删除！");
                      return;
                    }

                    // 如果没有，则正常删除
                    const deletedRows = orderPlayerList.filter(item => item.rowId === row.rowId);
                    this.reportOrderPlayerSnapshot('拼场删除', '用户点击删除拼场', '用户点击删除拼场行，准备删除同一 rowId 下的拼场和收款行', {
                      deleteTarget: {
                        rowId: row.rowId || '',
                        deletedTotal: deletedRows.length,
                        deletedRows
                      }
                    });
                    for (let i = 0; i < orderPlayerList.length; i++) {
                      if (orderPlayerList[i].rowId === row.rowId) {
                        this.subTableRow(i);
                        i--; // 删除后数组下标前移，需要回退
                      }
                    }
                  }
                },
                {label: "已退人数", prop: 'playerTuiNum', type: 'text', show: false, width: 80, sum: true,},
                {
                  label: "联系方式",
                  prop: 'contactType',
                  type: 'inputtag',
                  show: true,
                  isValid: 'digitsStar',
                  max: 11,
                  width: 220,
                  trigger: 'Enter',
                  triggerMode: 'manual-auto',
                  tagPattern: '^[0-9*]{1,11}$',
                  autoTriggerLength: 11,
                  tagValidateMessage: '联系方式最多输入11位，按Enter才可添加',
                  tagInvalidCharMessage: '联系方式只能输入数字或*号',
                  separator: ',',
                  saveOnBlur: false,
                  placeholder: '输入联系方式，满11位自动添加',
                  tagClick: (value, tagIndex, row, rowIndex, item) => {
                    this.openEditContactTag(value, tagIndex, row, rowIndex, item);
                  },
                },
                {label: "备注", prop: 'note', type: 'input', show: true, max: 50,},
                {label: "应收金额", prop: 'shouldPayAmount', type: 'text', width: 70, show: true, sum: true,},
                {
                  label: "收款方式", prop: 'payMode', type: 'selectImg', sourceList: [],
                  sourceProp: {text: 'displayValue', value: 'logicValue'},
                  change: (e, item, index) => {
                    this.payModeChange(e, item);
                  }
                },
                {label: "会员信息", prop: 'customerInfo', type: 'text', width: 120, show: false,},
                {
                  label: "收款金额", prop: 'payAmount', type: 'input', max: 8, isValid: 'money', width: 100, sum: true,
                  input: res => {
                    this.setTotalPayAmount();
                  }
                },
                {
                  label: "支付状态", prop: 'transStat', type: 'tag',
                  tags: [
                    {value: "W", type: 'info', text: '等待支付'},
                    {value: "P", type: 'success', text: '支付中..'},
                    {value: "F", type: 'danger', text: '支付失败'},
                    {value: "S", type: 'success', text: '支付成功'}
                  ], show: false, width: 100,
                },
                {label: "退款信息", prop: 'tuiAmountStr', type: 'textLong', width: 80, show: false,},
                {
                  label: "收款操作", prop: 'shoukuanBtn', type: 'button', width: 80,
                  buttons: [
                    {label: '删除收款方式', prop: 'jian', type: 'primary', icon: 'Minus',},
                    {label: '增加收款方式', prop: 'jia', type: 'primary', icon: 'Plus',},
                    {label: '发起支付', svg: 'pay', prop: 'pay', type: 'primary'},
                  ],
                },

              ],
              data: [],
              spanMethod: (row, column, rowIndex, columnIndex) => {
                return this.tableSpanMethod(row, column, rowIndex, columnIndex);
              },
              btnClick: (type, row, index) => {
                switch (type) {
                    //region 增加收款
                  case 'jia':
                    if (!this.validatePay()) return false
                    this.addTableRow(1, row);
                    break;
                    //endregion
                    //region 减少收款
                  case 'jian':
                    this.reportOrderPlayerSnapshot('收款行删除', '用户点击删除收款方式', '用户点击删除单条收款方式行', {
                      deleteTarget: {
                        rowIndex: index,
                        row
                      }
                    });
                    this.subTableRow(index);
                    break;
                    //endregion
                    //region 发起汇付 付款
                  case 'pay':
                    if (!this.formData.data.themeName) {
                      this.$message.warning(`请选择主题!`);
                      return false
                    }

                    // 发起汇付付款时要校校验参数有效性 有无效数据 禁止唤起支付弹窗
                    if (!this.validateParams(this.buildParams())) return false
                    if (row.payAmount === '' || row.payAmount === '0') {
                      this.$message.warning('请输入有效收款金额。');
                      return false
                    }
                    if (this.showBox && this.status === 'P') {
                      this.$message.warning('当前已有一笔小白盒支付处理中');
                      return false
                    }
                    // open scan box
                    this.payRow = {}
                    this.showBox = true
                    this.isClosePay = false
                    // reset pay status
                    this.status = ""
                    break;
                }
              }
            },
          },
          //endregion
          {label: "玩家总数", prop: 'totalPeopleNum', type: 'text', disabled: true},
          {label: "应收结算", prop: 'totalReceivePrice', type: 'text', disabled: true},
          {label: "实收结算", prop: 'totalPayAmount', type: 'text', disabled: true},
          //region 验券信息 极迅小白盒验券信息 抖音 美团
          {label: "验券信息", prop: 'baiheCodeTitle', type: 'title', show: false},
          {
            label: "验券信息", prop: 'orderVerifyList', type: 'table', show: false,
            tableData: {
              column: [
                {type: 'index'},
                //条件
                {
                  label: "日期",
                  prop: 'date',
                  type: 'date',
                  show: true,
                  condition: "date",
                  width: 250,
                  isPower: false,
                  visible: false,
                },
                //列
                {label: "商品信息", prop: 'goodsName', type: 'text', show: true},
                {label: "券码", prop: 'receiptCode', type: 'text', show: true,
                  popover: {
                    content: "抖音验券码，一小时后展示，美团验券码，立即返回展示。",
                    placement: "top-start",
                    width:220
                  }
                },
                {
                  label: "验券金额", prop: 'couponPayAmount', type: 'text',
                  popover: {
                    content: "实际到账扣点前金额。",
                    placement: "top-start",
                    width:170
                  }
                },
                {
                  label: "优惠信息", prop: 'html', type: 'html',  show: true,
                  popover: {
                    content: "优惠信息包含商家立减，平台支付优惠等活动，无优惠-不显示。",
                    placement: "top-start",
                    width:220
                  }
                },
                {label: "验券时间", prop: 'verifyTime', type: 'time', show: true,},
              ],
              data: [],
              isStripe:false,
            },

          },
          //endregion

          //region 优惠券验券信息
          {label: "验券信息", prop: 'couponCodeTitle', type: 'title', show: false},
          {
            label: "验券信息", prop: 'playerCouponList', type: 'table', show: false,
            tableData: {
              column: [
                {type: 'index'},
                //条件
                {
                  label: "日期",
                  prop: 'date',
                  type: 'date',
                  show: true,
                  condition: "date",
                  width: 250,
                  isPower: false,
                  visible: false,
                },
                //列
                {label: "会员信息", prop: 'goodsName', type: 'text', show: true},
                {label: "券码", prop: 'receiptCode', type: 'text', show: true},
                {label: "验券金额", prop: 'price', type: 'text'},
                {label: "验券时间", prop: 'verifyTime', type: 'time', show: true,},
              ],
              data: [],
            },

          },
          //endregion
          {label: "订单信息", prop: 'title', type: 'title',},
          {
            label: "订单种类", prop: 'orderMode', type: 'radio', show: false, width: 220,
            sourceList: [{value: '1', text: '正常'}, {value: '2', text: '加班'}]
          },
          {
            label: "场次类型", prop: 'tags', type: 'radio', width: 220,
            sourceList: [{value: '0', text: '拼场'}, {value: '1', text: '包场'}]
          },
          {
            label: "客群类型",
            prop: 'customerType',
            type: 'checkbox',
            isLine: true,
            width: 1500,
            sourceList: [],
            lineWidth: 90,
            sourceProp: {text: 'displayValue', value: 'logicValue'},
          },
          {
            label: "订单来源",
            prop: 'orderSource',
            type: 'checkbox',
            isLine: true,
            width: 1500,
            sourceList: [],
            lineWidth: 90,
            sourceProp: {text: 'displayValue', value: 'logicValue'},
          },
          {label: "岗位信息", prop: 'job', type: 'title', show: false},
        ],
        rules: {
          themeName: [
            {required: true, message: '请选择主题', trigger: 'change'},
          ],
          orderCreateTime: [
            {required: true, message: '请选择下单日期', trigger: 'change'},
          ],
          sessionTime: [
            {required: true, message: '请选择下单场次', trigger: 'change'},
          ],
        },
        data: {},
      },
      //endregion
      //region 窗口数据
      dialogWin: {
        state: false,
        title: '',
        type: 'table',
        saveBtn: false,
        currData: null,
        //窗口取消重新设置表格
        onClose: res => {
          this.setTable();
        },
      },
      //endregion
      //region 客户数据
      customerTableData: {
        form: {},
        column: [
          {type: 'index'},
          {label: "客户名称", prop: 'originAccountName', type: 'text', show: true,},
          {label: "电话号码", prop: 'phone', type: 'text', show: true, condition: "like"},
          {label: "品牌名称", prop: 'brandName', type: 'text', show: true,},
          {label: "卡片名称", prop: 'cardName', type: 'text', show: true,},
          {label: "剩余余额", prop: 'jine', type: 'text', show: true,},
          {label: "剩余次数", prop: 'cishu', type: 'text', show: true,},
          {
            label: "激活状态", prop: 'hasDraft', type: 'tag', show: true, condition: "select", width: 90,
            tags: [
              {value: 0, type: 'success', text: '已激活'},
              {value: 1, type: 'danger', text: '待激活'}
            ],
          },
        ],
        data: [],
        searchClick: res => {
          this.selectCustomerClick();
        },
        rowClick: (row) => {
          this.confirmCustomerClick(row)
        }
      },
      //endregion
      //region 查询已有订单数据
      orderTableData: {
        form: {},
        column: [
          //条件
          {label: "关键词", prop: 'unionField', type: 'text', visible: false, condition: "like",},
          //列
          {type: 'index'},
          {label: "订单单号", prop: 'orderNo', type: 'text', show: true, condition: "like",},
          {label: "主题名称", prop: 'themeName', type: 'text', show: true, isPower: false, width: 160,},
          {label: "下单日期", prop: 'orderCreateTime', type: 'time', show: true, width: 160, condition: 'time'},
          {label: "场次", prop: 'sessionTime', type: 'text', show: true, width: 140, isPower: false,},
          {label: "订单人数", prop: 'peopleNum', type: 'text', show: true, width: 90,},
          {label: "创建者", prop: 'createUserName', type: 'text', show: true, isPower: false,},
          {label: "备注", prop: 'note', type: 'textLong', show: true},
        ],
        data: [],
        searchClick: res => {
          this.searchOrderClick()
        },
        rowClick: (row) => {
          this.confirmOrderClick(row)
        }
      },
      //endregion
      restoreTimer: null,
      statusCheckController: null,
    }
  },
  methods: {
    //region 小白盒扫描动作
    //扫描动作
    handleScanned(code) {
      this.status = "P"; // 等待支付
      this.isClosePay = true;
    },
    async handlePay(orderCode) {
      let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      // 遍历修改
      orderPlayerList.forEach(item => {
        if (item.payMode === 20 && !item.microPayDTO && !item.bspayId) {
          item.authCode = orderCode
        }
      });
      // 生成参数
      let param = this.buildParams();
      this.saveOrder(param, {
        backOnSuccess: false,
        //支付后回调
        onSuccess: (res) => {
          // 支付成功后重新查询订单状态
          this.getOrderInfo(res.data.id)
          //修改订单状态
          // this.showBox = false
          //如果进入支付动作 进行关闭弹窗
          this.isClosePay = true;
          //再回调中查找汇付支付方式并且已经支付并且等待付款结果的支付row
          this.payRow = res.data.orderPlayerList.reduce((found, item) => {
            if (found) return found;
            // 否则在当前 item.orderPays 中查找符合条件的项
            const matchedPay = item.orderPays.find(pay =>
                pay.payMode === 20 &&
                pay.bspayId &&
                pay.isNew
            );
            return matchedPay || null; // 返回第一个匹配项，否则继续查找
          }, null); // 初始值为 null
          if (this.payRow) {
            //如果支付成功向本地缓存添加信息
            this.savePayInfoAndStartScan(res.data.id, orderCode);
          }

        }
      });
    },
    //轮询查询支付状态
    handlePoll(e) {
      let data = {
        bsPayId: this.payRow.bspayId,
        payMode: this.payRow.payMode,
      }
      this.$POST("/customer/bsorder/trade/payment/micropay/result", data).then(res => {
        if (res.code === 200) {
          this.status = res.data.trans_stat
          if (res.data.trans_stat === "F") {
            //清除本地支付信息
            this.clearPayInfo()
            this.$tools.getIndex(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column,
                "transStat").show = false
            setTimeout(() => {
              this.showBox = false
              this.isClosePay = false
              this.getOrderInfo(this.formData.data.id)
            }, 500)
          }
          //支付成功后关闭支付弹窗
          if (res.data.trans_stat === "S") {
            this.showBox = false
            //清除本地支付信息
            this.clearPayInfo()
            const themePrice = this.formData.data.themePrice;
            let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
            const groups = {};
            for (const item of orderPlayerList) {
              if (!groups[item.rowId]) {
                groups[item.rowId] = {
                  rowId: item.rowId,
                  playerNum: item.playerNum || 0,
                  totalPayAmount: 0,
                  items: []
                };
              }
              //累加
              groups[item.rowId].totalPayAmount = this.$tools.accAdd(
                  groups[item.rowId].totalPayAmount,
                  item.payAmount
              );

              if (item.playerNum) {
                groups[item.rowId].playerNum = item.playerNum;
              }

              groups[item.rowId].items.push(item);
            }
            for (const group of Object.values(groups)) {
              const shouldPayAmount = this.$tools.accMul(group.playerNum, themePrice);
              const isEnough = group.totalPayAmount === shouldPayAmount;
              const lastPayMode = [...group.items].reverse().find(p => p.payMode === 20);
              //查到最后一笔汇付的值 并且用户支付过bspayId有值，并且单次支付不是全额付款
              if (lastPayMode && lastPayMode.bspayId && !isEnough && lastPayMode.orderPlayerId === this.payRow.orderPlayerId) {
                lastPayMode.transStat = "S"
                this.addTableRow(1, lastPayMode);
              } else {
                const matchedItems = orderPlayerList.filter(item => item.bspayId === this.payRow.bspayId);
                // 修改匹配到的每一项的属性
                matchedItems.forEach(item => {
                  // 禁用收款金额
                  item.payAmountdisabled = true;
                  // 禁用收款方式
                  item.payModedisabled = true;
                  item.jianBtn = false;
                  item.payBtn = false;
                  //修改当前订单状态
                  item.transStat = "S"
                });
                // 校验惠付支付，如果开单过程中有汇付支付并且支付成功就要显示退款按钮
                // this.$tools.getIndex(this.formData.form, 'button').diy5.show = true;
              }
            }
          }
        }
      }).catch(err => {
        this.status = 'F'
        this.showBox = false
        this.isClosePay = false
        this.clearPayInfo()
      })
    },
    //endregion
    //region 验证汇付支付方式是否支付过
    validatePay() {
      let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      if (!Array.isArray(orderPlayerList)) {
        this.reportOrderValidateFailure('汇付支付校验失败', '拼场表格数据异常，无法校验小白盒汇付支付状态', {
          failureType: 'orderPlayerList_not_array',
          rawOrderPlayerList: orderPlayerList
        });
        return false;
      }
      for (let index = 0; index < orderPlayerList.length; index++) {
        const item = orderPlayerList[index];
        if (item.payMode === 20) {
          // 如果 payMode 为汇付 ，就检查 bspayId 是否支付过
          if (!item.hasOwnProperty("bspayId") || !item.bspayId && !item.hasOwnProperty("transStat") || item.transStat !== "S") {
            this.reportOrderValidateFailure('汇付支付未完成', '保存前发现小白盒汇付收款未支付完成，阻止继续保存或验券', {
              failureType: 'huifu_pay_unfinished',
              rowIndex: index,
              failedRow: item,
              requiredCondition: 'payMode=20 时必须存在 bspayId 且 transStat=S'
            });
            this.$message.warning('请先支付小白盒收款');
            return false

          }
        }
      }

      return true;
    },
    //endregion
    //region 小白盒验券 美团/抖音
    //识别到码
    async onYanQuanScanSuccess(e) {
      let {type, code} = e
      this.ensureYanQuanFlowId(true);
      this.yanQuanConfig.status = 'scanning'
      if (this.$refs.yanQuanScanBox.stage !== 1) return false;
      this.setYanQuanBusinessBusy(true);
      try {
        switch (type) {
          case 'coupon':
            await this.handleCouponScanSuccess(code);
            break
          case 'meituan':
            //只有一阶段
            let res = await this.checkMeituanCoupon(code)
            if (res.code === 200) {
              this.yanQuanConfig.receiptCode = res.data.receiptCode
              //赋值商品名称
              this.yanQuanConfig.details = res.data.dealTitle
              //最大验券数量
              this.yanQuanConfig.max = res.data.count
              // this.yanQuanConfig.payAmount = 0
              //重新扫码后要重置验券数量
              this.yanQuanConfig.value = 1
              this.$refs.yanQuanScanBox.goStage(2)
            }
            break;
          case 'douyin':
            let douyinRes = await this.checkDouYinCoupon(code)
            if (douyinRes.code === 200) {
              this.yanQuanConfig.receiptCode = douyinRes.data.couponCode
              //赋值商品名称
              this.yanQuanConfig.details = douyinRes.data.certificates[0].sku.title
              //最大验券数量
              this.yanQuanConfig.max = douyinRes.data.certificates.length
              //当前订单中所有验券信息
              this.yanQuanConfig.certificatesArr = douyinRes.data.certificates.map(item => {
                return {
                  receiptCode: '-',
                  encryptedCode: item.encrypted_code,
                  data: {
                    amount: item.amount,
                    sku: item.sku
                  }
                }
              })
              //抖音验券token
              this.yanQuanConfig.verifyToken = douyinRes.data.verify_token
              //重新扫码后要重置验券数量
              this.yanQuanConfig.value = 1
              this.$refs.yanQuanScanBox.goStage(2)
            }
            break;
        }
      } finally {
        this.setYanQuanBusinessBusy(false);
        this.scheduleYanQuanLogFlush(0);
      }
    },
    //验券成功后
    parseCouponScanCode(code) {
      try {
        const data = JSON.parse(String(code || '').trim());
        if (data && data.key === 'coupon' && data.playerCouponId) {
          return data;
        }
      } catch (err) {
        return null;
      }
      return null;
    },
    usePlayerCoupon(playerCouponId) {
      return this.$POST("/customer/EomsMarketing/coupon/use", {
        playerCouponId,
        shopId: this.$store.state.shopInfo.id,
      });
    },
    bindPlayerCoupon(playerCouponId, orderId) {
      return this.$POST("/customer/EomsMarketing/coupon/bind", {
        playerCouponId,
        orderId,
        shopId: this.$store.state.shopInfo.id,
      });
    },
    async ensureCouponBindOrderId() {
      if (this.formData.data.id) {
        return this.formData.data.id;
      }

      const param = this.validateParams(this.buildParams());
      if (!param) {
        return '';
      }

      const res = await this.saveOrder(param, {backOnSuccess: false, throwOnError: true});
      return res && res.data ? res.data.id : '';
    },
    async handleCouponScanSuccess(code) {
      if (this.yanQuanChecking) {
        this.$message.warning('正在验券，请稍候');
        return;
      }

      const couponData = this.parseCouponScanCode(code);
      if (!couponData) {
        this.$message.error('优惠券二维码格式不正确');
        return;
      }

      this.yanQuanChecking = true;
      try {
        const playerCouponId = couponData.playerCouponId;
        const useRes = await this.usePlayerCoupon(playerCouponId);
        if (!useRes || useRes.code !== 200) {
          this.$message.error('优惠券验券失败，请稍后重试');
          return;
        }

        this.$message.success('优惠券验券成功');
        try {
          await ElMessageBox.confirm('是否绑定当前优惠券到当前订单？', '优惠券验券成功', {
            confirmButtonText: '绑定',
            cancelButtonText: '暂不绑定',
            type: 'success',
          });
        } catch (err) {
          this.yanQuanConfig.visible = false;
          return;
        }

        const orderId = await this.ensureCouponBindOrderId();
        if (!orderId) {
          this.$message.warning('请先完善订单信息后再绑定优惠券');
          return;
        }

        await this.bindPlayerCoupon(playerCouponId, orderId);
        this.$message.success('优惠券绑定成功!');
        await this.getOrderInfo(orderId);
        this.yanQuanConfig.visible = false;
      } catch (err) {
        const errMsg = err && err.msg ? err.msg : '优惠券验券失败，请稍后重试';
        this.$message.error(errMsg);
      } finally {
        this.yanQuanChecking = false;
      }
    },
    getYanQuanLogStringify(data) {
      const seen = new WeakSet();
      return JSON.stringify(data, (key, value) => {
        if (value instanceof Error) {
          return {
            name: value.name,
            message: value.message,
            stack: value.stack,
            code: value.code || '',
            status: value.status || '',
            responseStatus: value.bindResponseStatus || (value.response && value.response.status) || '',
            requestData: value.bindRequestData || null,
            responseData: value.bindResponseData || (value.response && value.response.data) || null
          };
        }
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) {
            return '[Circular]';
          }
          seen.add(value);
        }
        return value;
      });
    },
    createYanQuanFlowId() {
      return `yanquan_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    },
    ensureYanQuanFlowId(reset = false) {
      if (reset || !this.yanQuanFlowId) {
        this.yanQuanFlowId = this.createYanQuanFlowId();
      }
      return this.yanQuanFlowId;
    },
    clearYanQuanFlowId() {
      this.yanQuanFlowId = '';
    },
    shouldReportYanQuanFlow() {
      return !!(
          this.yanQuanFlowId
          || this.yanQuanConfig.type
          || (Array.isArray(this.yanQuanConfig.verifyCodeArr) && this.yanQuanConfig.verifyCodeArr.length)
      );
    },
    getClientLogInfo() {
      return {
        clientSource: '网页端'
      };
    },
    getYanQuanVerifyTypeName(type) {
      const typeMap = {
        douyin: '抖音',
        meituan: '美团'
      };
      return typeMap[type] || type || '';
    },
    getYanQuanLogText(text) {
      const textMap = {
        bind_order: '绑券流程',
        order_save: '订单保存',
        verify_submit: '验券提交',
        pay_row_update: '收款行更新',
        prepare: '验券预检',
        start: '开始',
        success: '成功',
        fail: '失败',
        error: '异常',
        canceled: '已取消',
        skip: '跳过',
        retrying: '重试中',
        retry_fail: '重试失败',
        deferred_fail: '暂记失败',
        partial_fail: '部分失败',
        prepare_empty: '无可绑定券',
        after_refresh: '订单回查完成',
        after_refresh_with_bind_error: '绑定异常后订单回查完成',
        bind_error: '绑定失败',
        '发现漏绑': '发现漏绑',
        '回查无漏绑': '回查无漏绑',
        '自动补绑成功': '自动补绑成功',
        '自动补绑后仍缺失': '自动补绑后仍缺失',
        '后台补绑异常': '后台补绑异常',
        duplicate: '重复绑定',
        timeout: '请求超时',
        network: '网络异常',
        used: '券已核销',
        not_found: '数据不存在',
        param: '参数错误',
        permission: '权限异常',
        server: '服务端异常',
        unknown: '未知错误',
        empty_item: '空券数据',
        already_bound: '已绑定过',
        missing_receiptCode: '缺少券码',
        missing_verifyId: '缺少抖音核销编号',
        'yanQuanConfig.verifyCodeArr': '本次验券成功列表',
        'batch bind start': '批量绑券开始',
        'batch bind skipped: empty ticket list': '批量绑券跳过：没有可绑定券码',
        'batch bind retry start': '批量绑券补绑开始',
        'batch bind partial fail': '批量绑券部分失败',
        'batch bind success': '批量绑券成功',
        'order update start': '订单修改开始',
        'order create start': '订单创建开始',
        'order update success': '订单修改成功',
        'order create success': '订单创建成功',
        'order save canceled': '订单保存已取消',
        'order save fail': '订单保存失败',
        'meituan verify submit start': '美团验券提交开始',
        'meituan verify submit success': '美团验券提交成功',
        'meituan verify submit canceled': '美团验券提交已取消',
        'meituan verify submit fail': '美团验券提交失败',
        first: '首次绑定',
        retry: '补绑'
      };
      return textMap[text] || text;
    },
    getYanQuanLogSnapshot(value, seen = new WeakSet()) {
      if (Array.isArray(value)) {
        return value.map(item => this.getYanQuanLogSnapshot(item, seen));
      }
      if (value && typeof value === 'object') {
        if (seen.has(value)) {
          return '[循环引用]';
        }
        seen.add(value);
        const data = {};
        Object.keys(value).forEach(key => {
          if (['stage', 'status', 'message', 'errorType', 'rejectReason', 'source', 'bindPass'].includes(key)) {
            data[key] = this.getYanQuanLogText(value[key]);
            return;
          }
          data[key] = this.getYanQuanLogSnapshot(value[key], seen);
        });
        return data;
      }
      return value;
    },
    getYanQuanLogPayload(payload = {}) {
      const shopInfo = this.$store.state.shopInfo || {};
      const companyInfo = this.$store.state.companyInfo || {};
      const userInfo = this.$store.state.userInfo || {};
      const currTheme = this.currTheme || {};
      const formData = this.formData && this.formData.data ? this.formData.data : {};
      const yanQuanConfig = this.yanQuanConfig || {};
      return {
        flowId: this.yanQuanFlowId || '',
        logTime: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"),
        pageName: '主题订单新增页',
        actionName: '验券扫码提交',
        verifyType: this.getYanQuanVerifyTypeName(yanQuanConfig.type),
        verifyLabel: yanQuanConfig.label || '',
        shopInfo: {
          companyId: companyInfo.companyId || '',
          companyName: companyInfo.companyName || companyInfo.companySimpleName || '',
          shopId: shopInfo.id || '',
          shopName: shopInfo.shopName || '',
          shopPhone: shopInfo.shopPhone || '',
          shopAddress: shopInfo.shopAddress || ''
        },
        operatorInfo: {
          userId: userInfo.id || '',
          userName: userInfo.nickName || userInfo.userName || userInfo.name || '',
          phone: userInfo.phone || ''
        },
        orderInfo: {
          orderCreateTime: formData.orderCreateTime || '',
          themeId: formData.themeName || '',
          themeName: currTheme.themeName || '',
          themePrice: formData.themePrice || '',
          sessionTime: formData.sessionTime || ''
        },
        verifyBaseInfo: {
          receiptCode: yanQuanConfig.receiptCode || '',
          details: yanQuanConfig.details || '',
          count: yanQuanConfig.value || '',
          verifyToken: yanQuanConfig.verifyToken || '',
          peopleNum: yanQuanConfig.peopleNum || '',
          payAmount: yanQuanConfig.payAmount || 0
        },
        clientInfo: this.getClientLogInfo(),
        ...this.getYanQuanLogSnapshot(payload)
      };
    },
    isCanceledRequestError(err) {
      if (!err) return false;
      const message = String(err.message || err.msg || err.code || '').toLowerCase();
      return err.name === 'CanceledError'
          || err.name === 'AbortError'
          || err.code === 'ERR_CANCELED'
          || message.includes('err_canceled')
          || message.includes('canceled');
    },
    async reportYanQuanStageLog(stage, status, message, payload = {}) {
      return this.reportYanQuanVerifyLog({
        stage,
        status,
        message,
        ...payload
      });
    },
    getOrderPlayerSnapshot(list) {
      let tableRows = [];
      try {
        tableRows = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data || [];
      } catch (err) {
        tableRows = [];
      }
      const safeList = Array.isArray(list)
          ? list
          : tableRows;
      const rows = safeList.map((item, index) => ({
        index,
        rowId: item.rowId || '',
        rowspan: item.rowspan,
        boxScan: !!item.boxScan,
        playerNum: item.playerNum || '',
        shouldPayAmount: item.shouldPayAmount || '',
        payMode: item.payMode || '',
        payAmount: item.payAmount || '',
        orderPlayerId: item.orderPlayerId || '',
        orderPayId: item.orderPayId || '',
        bspayId: item.bspayId || '',
        transStat: item.transStat || '',
      }));
      const groupIds = [];
      rows.forEach(item => {
        if (item.rowspan > 0 && item.rowId && !groupIds.includes(item.rowId)) {
          groupIds.push(item.rowId);
        }
      });
      return {
        totalRows: rows.length,
        totalGroups: groupIds.length,
        boxScanRows: rows.filter(item => item.boxScan),
        rows
      };
    },
    reportOrderPlayerSnapshot(stage, status, message, payload = {}) {
      return this.reportYanQuanStageLog(stage, status, message, {
        orderPlayerSnapshot: this.getOrderPlayerSnapshot(),
        ...payload
      });
    },
    getOrderValidateValueState(value) {
      return {
        value: value === undefined ? '未定义' : value === null ? 'null' : value,
        valueType: value === null ? 'null' : Array.isArray(value) ? 'array' : typeof value,
        isEmptyString: value === '',
        isNullOrUndefined: value === null || value === undefined,
        isFalsy: !value,
        isZeroLike: value === 0 || value === '0'
      };
    },
    getOrderValidateFieldSnapshot(prop) {
      const formData = this.formData && this.formData.data ? this.formData.data : {};
      let formItem = {};
      try {
        formItem = this.$tools.getIndex(this.formData.form, prop) || {};
      } catch (err) {
        formItem = {};
      }
      const sourceList = Array.isArray(formItem.sourceList) ? formItem.sourceList : [];
      const currentValue = formData[prop];
      const selectedSource = sourceList.find(item =>
          item && (item.id === currentValue || item.value === currentValue || item.sessionTime === currentValue)
      ) || null;
      return {
        prop,
        disabled: !!formItem.disabled,
        hidden: !!formItem.hidden,
        currentValue: this.getOrderValidateValueState(currentValue),
        sourceTotal: sourceList.length,
        selectedSource: selectedSource ? {
          id: selectedSource.id || '',
          value: selectedSource.value || selectedSource.sessionTime || '',
          text: selectedSource.themeName || selectedSource.sessionTimeText || selectedSource.text || ''
        } : null
      };
    },
    getOrderValidateRowCause(row = {}, rowIndex = -1) {
      return {
        rowIndex,
        rowNo: rowIndex >= 0 ? rowIndex + 1 : '',
        rowId: row.rowId || '',
        rowspan: row.rowspan,
        boxScan: !!row.boxScan,
        orderPlayerId: row.orderPlayerId || '',
        orderPayId: row.orderPayId || '',
        fieldValues: {
          payMode: this.getOrderValidateValueState(row.payMode),
          payAmount: this.getOrderValidateValueState(row.payAmount),
          playerNum: this.getOrderValidateValueState(row.playerNum),
          shouldPayAmount: this.getOrderValidateValueState(row.shouldPayAmount),
          bspayId: this.getOrderValidateValueState(row.bspayId),
          transStat: this.getOrderValidateValueState(row.transStat)
        }
      };
    },
    getOrderValidateFailureCause(failureType, context = {}) {
      const yanQuanConfig = this.yanQuanConfig || {};
      const formData = this.formData && this.formData.data ? this.formData.data : {};
      const row = context.failedRow || context.row || {};
      const rowIndex = typeof context.rowIndex === 'number' ? context.rowIndex : -1;
      const base = {
        failureType,
        reason: '',
        triggerCondition: '',
        possibleReason: '',
        formFields: {
          themeName: this.getOrderValidateFieldSnapshot('themeName'),
          sessionTime: this.getOrderValidateFieldSnapshot('sessionTime')
        },
        submitBase: {
          id: context.submitParamSnapshot && context.submitParamSnapshot.id || formData.id || '',
          orderCode: context.submitParamSnapshot && context.submitParamSnapshot.orderCode || formData.orderCode || '',
          themeName: context.submitParamSnapshot && context.submitParamSnapshot.themeName || formData.themeName || '',
          sessionTime: context.submitParamSnapshot && context.submitParamSnapshot.sessionTime || formData.sessionTime || '',
          orderPlayerCount: context.submitParamSnapshot && Array.isArray(context.submitParamSnapshot.orderPlayerList)
              ? context.submitParamSnapshot.orderPlayerList.length
              : ''
        },
        yanQuanState: {
          visible: !!yanQuanConfig.visible,
          type: this.getYanQuanVerifyTypeName(yanQuanConfig.type),
          receiptCode: yanQuanConfig.receiptCode || '',
          verifyCodeTotal: Array.isArray(yanQuanConfig.verifyCodeArr) ? yanQuanConfig.verifyCodeArr.length : 0,
          flowId: this.yanQuanFlowId || ''
        }
      };
      const reasonMap = {
        missing_themeName: {
          reason: '主题字段为空，保存参数无法确定订单商品',
          triggerCondition: '!formData.data.themeName',
          possibleReason: '页面未选择主题、主题切换时被重置、订单详情未回填主题，或提交前页面数据被清空'
        },
        missing_sessionTime: {
          reason: '场次字段为空，保存参数无法确定订单开始结束时间',
          triggerCondition: '!formData.data.sessionTime',
          possibleReason: '页面未选择场次、主题切换后场次被清空、场次下拉未加载完成，或订单详情未回填场次'
        },
        missing_payAmount: {
          reason: '该拼场行已经有收款方式，但实收金额为空',
          triggerCondition: 'row.payMode 存在，且 row.payAmount 为 null/undefined/空字符串',
          possibleReason: '新增或编辑收款行后只选择了收款方式但未填写金额，或删除/重算收款时金额被清空'
        },
        missing_payMode: {
          reason: '该拼场行已经有实收金额，但收款方式为空',
          triggerCondition: 'row.payAmount 存在，且 !row.payMode',
          possibleReason: '白盒或手工编辑写入了金额但未写入收款方式，或员工后续把收款方式清空后再次提交'
        },
        missing_playerNum: {
          reason: '该拼场行有收款信息，当前又不是验券弹窗内保存，但拼场人数为空',
          triggerCondition: '(row.payMode || row.payAmount) && 人数为空 && row.rowspan > 0 && !yanQuanConfig.visible',
          possibleReason: '验券流程结束后白盒拼场行人数按需求置空，员工再次普通保存时会触发；也可能是手工新增拼场后未填人数'
        },
        orderPlayerList_not_array: {
          reason: '拼场表格数据不是数组，无法继续校验',
          triggerCondition: '!Array.isArray(orderPlayerList)',
          possibleReason: '页面表格组件尚未初始化、表格数据被异常覆盖，或订单详情回填结构异常'
        },
        huifu_pay_unfinished: {
          reason: '汇付收款行未完成支付，保存前被拦截',
          triggerCondition: 'payMode=20 时缺少 bspayId 或 transStat 不是 S',
          possibleReason: '用户发起了汇付收款但尚未支付成功，或支付状态没有回写到当前拼场行'
        }
      };
      Object.assign(base, reasonMap[failureType] || {
        reason: '保存参数校验未通过',
        triggerCondition: '未知校验条件',
        possibleReason: '需要结合 failedRow、submitBase 和 orderPlayerSnapshot 排查'
      });
      if (row && Object.keys(row).length) {
        base.rowCause = this.getOrderValidateRowCause(row, rowIndex);
      }
      return base;
    },
    reportOrderValidateFailure(status, message, payload = {}) {
      const yanQuanConfig = this.yanQuanConfig || {};
      const formData = this.formData && this.formData.data ? this.formData.data : {};
      return this.reportYanQuanStageLog('保存前校验失败', status, message, {
        validationInfo: {
          isYanQuanFlow: !!(this.yanQuanFlowId || yanQuanConfig.visible || (Array.isArray(yanQuanConfig.verifyCodeArr) && yanQuanConfig.verifyCodeArr.length)),
          yanQuanVisible: !!yanQuanConfig.visible,
          verifyType: this.getYanQuanVerifyTypeName(yanQuanConfig.type),
          flowId: this.yanQuanFlowId || '',
          orderId: formData.id || '',
          themeId: formData.themeName || '',
          sessionTime: formData.sessionTime || '',
        },
        validationCause: this.getOrderValidateFailureCause(payload.failureType || 'unknown', payload),
        orderPlayerSnapshot: this.getOrderPlayerSnapshot(),
        ...payload
      });
    },
    async reportYanQuanVerifyLog(payload = {}) {
      const logPayload = this.getYanQuanLogPayload(payload);
      enqueueYanQuanLog(this.getYanQuanLogStringify(logPayload));
    },
    setYanQuanBusinessBusy(isBusy) {
      if (this.yanQuanBusinessBusy === isBusy) return;
      this.yanQuanBusinessBusy = isBusy;
      setYanQuanLogBusinessBusy(isBusy);
    },
    scheduleYanQuanLogFlush(delay = 800) {
      scheduleYanQuanLogFlush(delay);
    },
    // 绑定失败重试前统一等待，避免连续瞬时请求把后端压得更紧。
    sleep(ms = 0) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    },
    // 兼容页面里不同来源的券数据，优先复用已有类型，其次按抖音字段兜底判断。
    getBindOrderType(item = {}) {
      if (item.type) return item.type;
      if (item.verifyId || item.douyinConsume) return "抖音";
      return "美团";
    },
    buildYanQuanBindTicket(item = {}) {
      const isDouyin = this.yanQuanConfig.type === 'douyin';
      const skuTitle = item.data && item.data.sku ? item.data.sku.title : item.receiptCode;
      const dealTitle = item.dealTitle || item.goodsName || item.receiptCode;
      return {
        goodsName: isDouyin ? `抖音-${skuTitle}` : `美团-${dealTitle}`,
        type: isDouyin ? "抖音" : "美团",
        receiptCode: item.receiptCode,
        operation: 1,
        verifyCount: 1,
        verifyTime: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"),
        verifyId: item.verifyId || '',
      };
    },
    getYanQuanBindTicketRejectReason(item = {}) {
      if (!item) return 'empty_item';
      if (item.isCodeNew === false) return 'already_bound';
      if (!item.receiptCode) return 'missing_receiptCode';
      if (this.yanQuanConfig.type === 'douyin' && !item.verifyId) return 'missing_verifyId';
      return '';
    },
    getYanQuanBindTicketLogInfo(item = {}, index = 0) {
      const skuTitle = item.data && item.data.sku ? item.data.sku.title : '';
      return {
        sourceIndex: index,
        goodsName: item.goodsName || item.dealTitle || skuTitle || '',
        type: this.yanQuanConfig.type || '',
        receiptCode: item.receiptCode || '',
        verifyId: item.verifyId || '',
        isCodeNew: item.isCodeNew,
        couponPayAmount: item.couponPayAmount || '',
        dealTitle: item.dealTitle || '',
        skuTitle
      };
    },
    buildYanQuanBindTicketsWithTrace() {
      const verifyCodeArr = Array.isArray(this.yanQuanConfig.verifyCodeArr)
          ? this.yanQuanConfig.verifyCodeArr
          : [];
      const data = [];
      const included = [];
      const excluded = [];
      verifyCodeArr.forEach((item, index) => {
        const rejectReason = this.getYanQuanBindTicketRejectReason(item);
        const sourceInfo = this.getYanQuanBindTicketLogInfo(item, index);
        if (rejectReason) {
          excluded.push({
            ...sourceInfo,
            rejectReason
          });
          return;
        }
        const bindTicket = this.buildYanQuanBindTicket(item);
        data.push(bindTicket);
        included.push({
          ...sourceInfo,
          bindTicket
        });
      });
      return {
        source: 'yanQuanConfig.verifyCodeArr',
        sourceTotal: verifyCodeArr.length,
        bindTotal: data.length,
        excludedTotal: excluded.length,
        data,
        included,
        excluded
      };
    },
    buildYanQuanBindTickets() {
      return this.buildYanQuanBindTicketsWithTrace().data;
    },
    scheduleRemedyMissingBindTickets(bindTickets, orderId, delay = 1500, reason = '首次绑券后后台确认') {
      const ticketsSnapshot = this.getBindOrderSnapshot(Array.isArray(bindTickets) ? bindTickets : []);
      if (!orderId || !Array.isArray(ticketsSnapshot) || !ticketsSnapshot.length) {
        return;
      }
      enqueueYanQuanBindRemedy({
        orderId,
        tickets: ticketsSnapshot,
        reason,
        logContext: this.getYanQuanLogPayload({
          stage: '后台补绑队列',
          status: '等待执行',
          message: '券码补绑任务已加入后台队列',
          bindInfo: {
            orderId,
            expectedTotal: ticketsSnapshot.length
          }
        })
      }, {
        delay
      });
    },
    // 绑定接口的入参在多个入口都会复用，统一在这里补齐公共字段。
    buildBindOrderParam(item, orderId) {
      return {
        ...item,
        type: this.getBindOrderType(item),
        operation: 1,
        orderId,
        verifyId: item.verifyId || ''
      };
    },
    getBindOrderSnapshot(data) {
      if (!data) return null;
      try {
        return JSON.parse(JSON.stringify(data));
      } catch (err) {
        return data;
      }
    },
    getBindOrderErrorResponse(err) {
      if (!err) return null;
      if (err.bindResponseData) return err.bindResponseData;
      if (err.response && err.response.data) return err.response.data;
      if (err.data) return err.data;
      if (err.msg || err.message || err.code || err.errorMsg || err.errorMessage) {
        return {
          code: err.code || '',
          msg: err.msg || err.message || err.errorMsg || err.errorMessage || ''
        };
      }
      return null;
    },
    getBindOrderErrorStatus(err) {
      return (err && (err.bindResponseStatus || (err.response && err.response.status) || err.status)) || '';
    },
    requestBindOrder(param, options = {}) {
      const data = this.$tools.getObjData(param);

      const url = param.type === "美团"
          ? "/abutment/groupPurchase/connectOrUnConnectOrder"
          : "/abutment/verify/connectOrUnConnectOrder";

      const request = this.$POST1(
          url,
          data,
          false,
          options.silent ? "" : "绑定券码中...",
          false,
          true
      );
      const requestData = this.getBindOrderSnapshot(data);

      return request
          .then(responseData => {
            return {
              bindApi: url,
              requestData,
              responseData: this.getBindOrderSnapshot(responseData)
            };
          })
          .catch(rawErr => {
            const err = rawErr && typeof rawErr === 'object'
                ? rawErr
                : new Error(String(rawErr || '券码绑定失败'));
            err.bindApi = url;
            err.bindRequestData = requestData;
            err.bindResponseData = this.getBindOrderSnapshot(this.getBindOrderErrorResponse(err));
            err.bindResponseStatus = this.getBindOrderErrorStatus(err);
            throw err;
          });
    },
    getBindOrderApi(param) {
      return param.type === "美团"
          ? "/abutment/groupPurchase/connectOrUnConnectOrder"
          : "/abutment/verify/connectOrUnConnectOrder";
    },
    // 绑定日志和验券日志共用同一套上报能力，这里只负责补绑定阶段特有字段。
    async reportBindOrderLog(payload = {}) {
      const bindErrorInfo = payload.error ? this.classifyBindOrderError(payload.error) : {};
      await this.reportYanQuanVerifyLog({
        stage: 'bind_order',
        errorType: payload.errorType || bindErrorInfo.errorType || '',
        errorReason: payload.errorReason || bindErrorInfo.errorReason || '',
        ...payload
      });
    },
    getBindOrderErrorMessage(err) {
      if (!err) return '';
      return String(
          err.msg ||
          err.errorMsg ||
          err.errorMessage ||
          err.name ||
          err.message ||
          (err.bindResponseData && (err.bindResponseData.msg || err.bindResponseData.message || err.bindResponseData.errorMsg || err.bindResponseData.errorMessage)) ||
          (err.data && (err.data.msg || err.data.message || err.data.errorMsg || err.data.errorMessage)) ||
          (err.response && err.response.data && (err.response.data.msg || err.response.data.message)) ||
          ''
      );
    },
    // 便于线上排查时直接按错误类型筛日志，而不是只看一段原始报错文案。
    classifyBindOrderError(err) {
      const rawMessage = this.getBindOrderErrorMessage(err);
      const message = rawMessage.toLowerCase();
      const status = err && (err.bindResponseStatus || (err.response && err.response.status) || err.status);
      const rawText = JSON.stringify(err || {}).toLowerCase();

      const code = err && (
          err.code ||
          err.status ||
          err.errorCode ||
          (err.bindResponseData && (err.bindResponseData.code || err.bindResponseData.errorCode)) ||
          (err.data && (err.data.code || err.data.errorCode)) ||
          (err.response && err.response.data && err.response.data.code)
      );

      if (this.isCanceledRequestError(err)) {
        return {errorType: '请求取消', errorReason: '请求已取消'};
      }

      if (Number(code) === 5002 || message.includes('数据重复') || message.includes('请勿重复添加数据') || message.includes('已绑定') || message.includes('重复') || message.includes('已存在') || status === 409) {
        return {errorType: '重复绑定', errorReason: '券码已绑定或重复提交'};
      }

      if (message.includes('timeout') || message.includes('超时') || status === 408) {
        return {errorType: '请求超时', errorReason: '请求超时'};
      }

      if (message.includes('network') || message.includes('连接') || message.includes('断开') || status === 502 || status === 503 || status === 504) {
        return {errorType: '网络异常', errorReason: '网络或网关异常'};
      }

      if (message.includes('已使用') || message.includes('已核销') || message.includes('已消费')) {
        return {errorType: '券已核销', errorReason: '券码已使用或已核销'};
      }

      if (message.includes('不存在') || message.includes('未找到') || status === 404) {
        return {errorType: '数据不存在', errorReason: '券码或订单不存在'};
      }

      if (message.includes('参数') || message.includes('格式') || message.includes('无效') || status === 400) {
        return {errorType: '参数错误', errorReason: '请求参数错误'};
      }

      if (message.includes('权限') || message.includes('未登录') || message.includes('禁止') || status === 401 || status === 403) {
        return {errorType: '权限异常', errorReason: '权限或登录状态异常'};
      }

      if (status >= 500) {
        return {errorType: '服务端异常', errorReason: '服务端异常'};
      }

      return {
        errorType: '未知错误',
        errorReason: rawMessage || '未知错误'
      };
    },
    shouldRetryBindError(err) {
      const info = this.classifyBindOrderError(err);

      return [
        '请求超时',
        '网络异常',
        '服务端异常',
        '请求取消'
      ].includes(info.errorType);
    },
    // 绑定成功后把当前券标成已绑定，避免后续重复提交同一张券。
    markBoundVerifyCode(param) {
      const verifyCodeArr = this.yanQuanConfig && Array.isArray(this.yanQuanConfig.verifyCodeArr)
          ? this.yanQuanConfig.verifyCodeArr
          : [];
      const boundItem = verifyCodeArr.find(v => {
        if (param.verifyId && v.verifyId) {
          return v.verifyId === param.verifyId;
        }
        return v.receiptCode === param.receiptCode;
      });
      if (boundItem) {
        boundItem.isCodeNew = false;
      }
    },
    // 把最终失败的绑定错误包装成统一结构，后续提示和日志都直接复用这里的字段。
    createBindOrderError(err, param, attempt, maxRetryTimes, index) {
      const sourceErr = err || {};
      const bindError = err instanceof Error ? err : new Error(err && err.msg ? err.msg : '券码绑定失败');
      bindError.isBindOrderError = true;
      bindError.bindTicket = {...param};
      bindError.bindIndex = index;
      bindError.bindAttempt = attempt;
      bindError.bindRetryTimes = maxRetryTimes;
      bindError.bindApi = sourceErr.bindApi || this.getBindOrderApi(param);
      bindError.bindRequestData = sourceErr.bindRequestData || this.getBindOrderSnapshot(param);
      bindError.bindResponseData = sourceErr.bindResponseData || this.getBindOrderSnapshot(this.getBindOrderErrorResponse(sourceErr));
      bindError.bindResponseStatus = this.getBindOrderErrorStatus(sourceErr);
      bindError.userMessage = `${param.goodsName || param.receiptCode || '券码'}绑定失败，已重试${maxRetryTimes}次，请稍后重试`;
      const bindErrorInfo = this.classifyBindOrderError(err);
      bindError.errorType = bindErrorInfo.errorType;
      bindError.errorReason = bindErrorInfo.errorReason;
      bindError.userMessage = `${param.goodsName || param.receiptCode || '券码'}绑定失败，已重试${maxRetryTimes}次，请稍后重试`;
      return bindError;
    },
    // 单张券的绑定重试逻辑，成功/重试/最终失败都会单独打日志。
    async bindOrderWithRetry(item, orderId, index = 0, options = {}) {
      const maxRetryTimes = 3;
      const retryDelay = 800;
      const param = this.buildBindOrderParam(item, orderId);
      const bindApi = this.getBindOrderApi(param);
      let lastError = null;
      for (let attempt = 1; attempt <= maxRetryTimes; attempt++) {
        try {
          const bindResponse = await this.requestBindOrder(param, options);
          param.isNew = false;
          if (!options.skipPageMutation) {
            this.markBoundVerifyCode(param);
          }
          await this.reportBindOrderLog({
            status: 'success',
            message: '券码绑定成功',
            bindApi,
            requestData: bindResponse.requestData,
            responseData: bindResponse.responseData,
            bindInfo: {
              orderId,
              runMode: options.runMode || '正常绑券',
              bindIndex: index,
              bindAttempt: attempt,
              bindRetryTimes: maxRetryTimes,
              goodsName: param.goodsName || '',
              type: param.type || '',
              receiptCode: param.receiptCode || '',
              verifyId: param.verifyId || ''
            }
          });
          return {param, attempt};
        } catch (err) {
          lastError = err;
          const bindErrorInfo = this.classifyBindOrderError(err);
          if (bindErrorInfo.errorType === '重复绑定') {
            param.isNew = false;
            if (!options.skipPageMutation) {
              this.markBoundVerifyCode(param);
            }
            await this.reportBindOrderLog({
              status: 'skip',
              message: '券码重复，跳过绑定',
              bindApi,
              errorType: bindErrorInfo.errorType,
              errorReason: bindErrorInfo.errorReason,
              requestData: err.bindRequestData || this.getBindOrderSnapshot(param),
              responseData: err.bindResponseData || this.getBindOrderSnapshot(this.getBindOrderErrorResponse(err)),
              responseStatus: this.getBindOrderErrorStatus(err),
              bindInfo: {
                orderId,
                runMode: options.runMode || '正常绑券',
                bindIndex: index,
                bindAttempt: attempt,
                bindRetryTimes: maxRetryTimes,
                goodsName: param.goodsName || '',
                type: param.type || '',
                receiptCode: param.receiptCode || '',
                verifyId: param.verifyId || ''
              },
              error: err
            });
            return {
              param,
              attempt,
              skipped: true
            };
          }
          const canRetry = this.shouldRetryBindError(err);
          const needRetry = attempt < maxRetryTimes && canRetry;

          await this.reportBindOrderLog({
            status: needRetry ? 'retrying' : 'fail',
            message: needRetry ? '券码绑定失败，准备重试' : '券码绑定失败',
            bindApi,
            errorType: bindErrorInfo.errorType,
            errorReason: bindErrorInfo.errorReason,
            requestData: err.bindRequestData || this.getBindOrderSnapshot(param),
            responseData: err.bindResponseData || this.getBindOrderSnapshot(this.getBindOrderErrorResponse(err)),
            responseStatus: this.getBindOrderErrorStatus(err),
            bindInfo: {
              orderId,
              runMode: options.runMode || '正常绑券',
              bindIndex: index,
              bindAttempt: attempt,
              bindRetryTimes: maxRetryTimes,
              goodsName: param.goodsName || '',
              type: param.type || '',
              receiptCode: param.receiptCode || '',
              verifyId: param.verifyId || ''
            },
            error: err
          });

          if (needRetry) {
            await this.sleep(retryDelay);
            continue;
          }

          throw this.createBindOrderError(err, param, attempt, maxRetryTimes, index);
        }
      }
      throw this.createBindOrderError(lastError, param, maxRetryTimes, maxRetryTimes, index);
    },
    async onYanQuanScanCheckCode(e) {
      if (this.yanQuanChecking) {
        this.$message.warning('正在验券，请稍候');
        return;
      }
      this.yanQuanChecking = true;
      this.setYanQuanBusinessBusy(true);
      try {
        //验券信息
        if (this.yanQuanConfig.type === 'douyin') {
          let payRowInfo = null;
          const arr = Array.isArray(this.yanQuanConfig.certificatesArr) ? this.yanQuanConfig.certificatesArr : [];
          const rawValue = Number(this.yanQuanConfig.value);
          const requested = Number.isFinite(rawValue) ? Math.max(1, rawValue) : 1;
          const count = Math.min(requested, arr.length || requested);

          // 若有真实数组且长度够，则取前 count 条；否则使用 mock（并再取 count）
          let selected = [];
          if (arr.length >= count && count > 0) {
            selected = arr.slice(0, count);
          }
          // 构建提交参数（如果后续要实际调用 submitDouYinCoupon 可启用）
          let douYinData = {
            verifyToken: this.yanQuanConfig.verifyToken,
            encryptedCodes: selected.map(item => item.encryptedCode).join(',')
          }
          let douYinCoupon = await this.submitDouYinCoupon(douYinData)
          if (!douYinCoupon || douYinCoupon.code !== 200 || !douYinCoupon.data || !Array.isArray(douYinCoupon.data.verify_results)) {
            await this.reportYanQuanVerifyLog({
              status: 'fail',
              message: '抖音验券返回数据异常',
              requestData: douYinData,
              responseData: douYinCoupon || null
            });
            this.$message.error('抖音核券失败，请稍后重试');
            return;
          }
          const verifyResults = douYinCoupon.data.verify_results;
          const verifyMap = new Map();
          verifyResults.forEach(item => {
            verifyMap.set(item.code, {
              verifyId: item.verify_id,
              originCode: item.origin_code
            });
          });
          selected.forEach(item => {
            const verifyData = verifyMap.get(item.encryptedCode);
            if (verifyData) {
              item.verifyId = verifyData.verifyId;
              item.receiptCode = verifyData.originCode;
            }

            // 添加 isCodeNew 标志，表示这是新验的券
            item.isCodeNew = true;
          });

          this.yanQuanConfig.verifyCodeArr.push(...selected)

          // 更新人数
          this.yanQuanConfig.peopleNum = this.yanQuanConfig.verifyCodeArr.length;
          let payAmount = 0
          this.yanQuanConfig.verifyCodeArr.forEach((item) => {
            const amountObj = item.data.amount || {};
            const diff1 = Number(this.$tools.accMul(
                this.$tools.accAdd(amountObj.coupon_pay_amount || 0, amountObj.platform_discount_amount || 0),
                0.01
            ));
            payAmount = this.$tools.accAdd(payAmount, diff1);
          });
          // 与美团分支一致：将/更新为白盒验券的收款行
          let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
          let existItem = orderPlayerList.find(i => i.boxScan);
          //根据验券的数量来计算拼场人数
          const playerNum = this.yanQuanConfig.verifyCodeArr.length;
          //根据人数 和 主题单价 计算应收金额
          const shouldPayAmount = playerNum * this.formData.data.themePrice || 0;
          if (!existItem) {
            const insertRowData = {
              shouldPayAmount,
              payMode: 9,
              playerNum:0,
              payAmount: payAmount,
              boxScan: true,
              rowspan: 1,
            };
            this.addTableRow(0, insertRowData);
            payRowInfo = {
              action: 'insert',
              rowIndex: 0,
              rowData: insertRowData
            };
          } else {
            existItem.shouldPayAmount = shouldPayAmount;
            existItem.payAmount = payAmount;
            existItem.payMode = 9;
            payRowInfo = {
              action: 'update',
              rowIndex: orderPlayerList.findIndex(i => i === existItem),
              rowData: {...existItem}
            };
            // existItem.playerNum = this.yanQuanConfig.verifyCodeArr.length;
          }

          // 唤起三阶段 验券详情界面
          // this.$refs.yanQuanScanBox.goStage(3);

          await this.reportYanQuanStageLog('pay_row_update', 'success', '抖音验券收款行更新成功', {
            payRowInfo,
            orderPlayerSnapshot: this.getOrderPlayerSnapshot(),
            requestData: {
              playerNum,
              shouldPayAmount,
              payAmount
            }
          });
          await this.reportYanQuanVerifyLog({
            status: 'success',
            message: '抖音验券成功',
            requestData: {
              ...douYinData,
              selectedCodes: selected.map(item => ({
                receiptCode: item.receiptCode || '',
                encryptedCode: item.encryptedCode || '',
                verifyId: item.verifyId || ''
              }))
            },
            payRowInfo,
            responseData: douYinCoupon
          });
        }
        if (this.yanQuanConfig.type === 'meituan') {
          let payRowInfo = null;
          let meiTuanData = {
            name: this.yanQuanConfig.details,
            count: this.yanQuanConfig.value,
            receiptCode: this.yanQuanConfig.receiptCode,
          }
          const mtCoupon = await this.submitMeituanCoupon(meiTuanData)
          //计算验券金额 并且累加实收金额
          if (!mtCoupon || mtCoupon.code !== 200 || !Array.isArray(mtCoupon.data)) {
            await this.reportYanQuanVerifyLog({
              status: 'fail',
              message: '美团验券返回数据异常',
              requestData: meiTuanData,
              responseData: mtCoupon || null
            });
            this.$message.error('美团核券失败，请稍后重试');
            return;
          }
          mtCoupon.data.forEach(item => {
            const payAmount = this.getMeituanPayAmount(item);
            item.couponPayAmount = payAmount;
            item.isCodeNew = true;
            this.yanQuanConfig.payAmount = this.$tools.accAdd(this.yanQuanConfig.payAmount, payAmount);
          });
          //添加券码
          this.yanQuanConfig.verifyCodeArr.push(...mtCoupon.data);
          let orderPlayerList = this.$tools.getIndex(
              this.formData.form,
              "orderPlayerList"
          ).tableData.data;
          //查找是否有白盒扫码的券
          let existItem = orderPlayerList.find(i => i.boxScan);
          //根据验券的数量来计算拼场人数
          const playerNum = this.yanQuanConfig.verifyCodeArr.length;
          //根据人数 和 主题单价 计算应收金额
          const shouldPayAmount = playerNum * this.formData.data.themePrice || 0;
          //如果是白盒验券 并且没有场次信息 就插入一条
          if (!existItem) {
            const insertRowData = {
              shouldPayAmount,
              payMode: 7,
              playerNum:0,
              payAmount: this.yanQuanConfig.payAmount,
              boxScan: true,
              rowspan: 1,
            };
            this.addTableRow(0, insertRowData);
            payRowInfo = {
              action: 'insert',
              rowIndex: 0,
              rowData: insertRowData
            };
          } else {
            //如果单次验券流程没有结束 重新修改信息
            existItem.shouldPayAmount = shouldPayAmount;
            existItem.payAmount = this.yanQuanConfig.payAmount;
            existItem.payMode = 7;
            payRowInfo = {
              action: 'update',
              rowIndex: orderPlayerList.findIndex(i => i === existItem),
              rowData: {...existItem}
            };
          }

          await this.reportYanQuanVerifyLog({
            status: 'success',
            message: '美团验券成功',
            requestData: meiTuanData,
            payRowInfo,
            orderPlayerSnapshot: this.getOrderPlayerSnapshot(),
            responseData: mtCoupon
          });
        }

        //唤起三阶段 验券详情界面
        this.$refs.yanQuanScanBox.goStage(3);

        // 生成参数
        let param = this.validateParams(this.buildParams());
        if (!param) return;
        await this.reportOrderPlayerSnapshot('白盒验券保存前拼场快照', '准备保存', '白盒验券保存订单前记录当前页面拼场和提交拼场', {
          submitOrderPlayerList: param.orderPlayerList || []
        });

        await this.saveOrder(param, {
          backOnSuccess: false,
          //支付后回调
          onSuccess: async (res) => {
            const bindTrace = this.buildYanQuanBindTicketsWithTrace();
            const data = bindTrace.data;
            await this.reportBindOrderLog({
              status: data.length ? '准备绑定' : '无可绑定券',
              message: data.length ? '根据本次验券列表生成绑券参数' : '本次验券列表没有可绑定券码',
              bindInfo: {
                orderId: res.data.id,
                source: bindTrace.source,
                sourceTotal: bindTrace.sourceTotal,
                bindTotal: bindTrace.bindTotal,
                excludedTotal: bindTrace.excludedTotal,
                tickets: bindTrace.included,
                excludedTickets: bindTrace.excluded,
                orderVerifyListUsage: 'orderVerifyList仅作为服务端回显展示，不参与前端绑券'
              }
            });
            // 订单创建成功后再绑定券，失败时在这里截住并补打一条绑定失败日志。
            const bindResult = await this.bindOrderSafe(data, res.data.id);
            await this.getOrderInfo(res.data.id);
            await this.reportBindOrderLog({
              status: bindResult.success ? '订单回查完成' : '绑定异常后订单回查完成',
              message: '绑券流程结束后已重新查询订单详情',
              bindInfo: {
                orderId: res.data.id,
                bindSuccess: bindResult.success,
                empty: !!bindResult.empty,
                successCount: bindResult.successCount,
                skipCount: bindResult.skipCount,
                failedIndex: bindResult.failedIndex
              }
            });
            this.scheduleRemedyMissingBindTickets(data, res.data.id, bindResult.success ? 1500 : 0, bindResult.success ? '首次绑券后后台确认' : '首次绑券失败立即补救');
            if (!bindResult.success) {
              const bindErrorInfo = this.classifyBindOrderError(bindResult.error);
              await this.reportYanQuanVerifyLog({
                status: 'bind_error',
                message: '券码绑定失败',
                errorType: bindErrorInfo.errorType,
                errorReason: bindErrorInfo.errorReason,
                bindTicket: bindResult.error && bindResult.error.bindTicket ? bindResult.error.bindTicket : null,
                error: bindResult.error || null
              });
              return;
            }
          }
        });
      } catch (err) {
        if (this.isCanceledRequestError(err)) {
          await this.reportYanQuanStageLog('verify_submit', 'canceled', '验券请求已取消', {
            error: err
          });
          return;
        }
        if (err && err.isBindOrderError) {
          const bindErrorInfo = this.classifyBindOrderError(err);
          await this.reportYanQuanVerifyLog({
            status: 'bind_error',
            message: '券码绑定失败',
            errorType: bindErrorInfo.errorType,
            errorReason: bindErrorInfo.errorReason,
            bindTicket: err.bindTicket || null,
            error: err
          });
          this.$message.error(err.userMessage || '券码绑定失败，请稍后重试');
          return;
        }
        await this.reportYanQuanVerifyLog({
          status: 'error',
          message: '验券流程异常',
          error: err
        });
        this.$message.error('核券失败，请检查券码后重试，或者重新刷新页面');
      } finally {
        this.yanQuanChecking = false;
        this.setYanQuanBusinessBusy(false);
        this.scheduleYanQuanLogFlush(0);
      }

    },
    //最终提交，计算拼场信息
    onYanQuanScanFinalSubmit() {
      // if (this.yanQuanConfig.type === 'meituan') {
      // 获取订单玩家列表
      const orderPlayerList = this.$tools.getIndex(
          this.formData.form,
          "orderPlayerList"
      ).tableData.data;
      // 查找白盒扫码的券
      const existItem = orderPlayerList.find(item => item.boxScan);
      // 若找到，更新人数
      if (existItem) {
        existItem.playerNum = '';
      }

      orderPlayerList.forEach(item => {
        item.boxScan = false;
      });
      // }
      // 清空验券配置
      this.yanQuanConfig.verifyCodeArr = [];
      this.yanQuanConfig.payAmount = 0;
      // this.yanQuanConfig.peopleNum = '';
      this.clearYanQuanFlowId();
      this.yanQuanConfig.visible = false
    },
    // 获取美团券信息
    checkMeituanCoupon(receiptCode) {
      return new Promise((resolve, reject) => {
        this.reportYanQuanStageLog('verify_submit', 'start', '美团验券提交开始', {
          requestData: {
            receiptCode,
            shopId: this.$store.state.shopInfo.id
          }
        });
        this.reportYanQuanStageLog('prepare', 'start', '美团验券预检开始', {
          requestData: {
            receiptCode,
            shopId: this.$store.state.shopInfo.id
          }
        });
        this.$POST("/abutment/meituan/tuangou/receipt/prepare", {
          receiptCode: receiptCode,
          content: 1,
          shopId: this.$store.state.shopInfo.id
        })
            .then(res => {
              this.reportYanQuanStageLog('prepare', 'success', '美团验券预检成功', {
                requestData: {
                  receiptCode,
                  shopId: this.$store.state.shopInfo.id
                },
                responseData: res
              });
              resolve(res); // 成功回传
            })
            .catch(err => {
              const isCanceled = this.isCanceledRequestError(err);
              this.reportYanQuanStageLog('prepare', isCanceled ? 'canceled' : 'fail', isCanceled ? '美团验券预检已取消' : '美团验券预检失败', {
                requestData: {
                  receiptCode,
                  shopId: this.$store.state.shopInfo.id
                },
                error: err
              });
              if (isCanceled) {
                reject(err);
                return;
              }
              this.$message.error("验券失败，请稍后重试");
              reject(err); // 失败回传
            });
      });
    },
    // 提交美团验券
    submitMeituanCoupon(param) {
      return new Promise((resolve, reject) => {
        this.reportYanQuanStageLog('verify_submit', 'start', 'meituan verify submit start', {
          requestData: {...param}
        });
        this.$POST("/abutment/meituan/tuangou/consume", param)
            .then(res => {
              this.reportYanQuanStageLog('verify_submit', 'success', 'meituan verify submit success', {
                requestData: {...param},
                responseData: res
              });
              this.$message.success("验券成功!");

              resolve(res);
            })
            .catch(err => {
              const isCanceled = this.isCanceledRequestError(err);
              this.reportYanQuanStageLog('verify_submit', isCanceled ? 'canceled' : 'fail', isCanceled ? 'meituan verify submit canceled' : 'meituan verify submit fail', {
                requestData: {...param},
                error: err
              });
              if (isCanceled) {
                reject(err);
                return;
              }
              const errMsg = err.msg;
              if (errMsg) {
                this.$messageBox.alert(errMsg, "提示");
              }
              reject(err); // 抛出错误
            });
      });
    },
    //endregion
    //region 抖音验券相关操作
    //获取抖音验券信息
    checkDouYinCoupon(receiptCode) {
      return new Promise((resolve, reject) => {
        this.reportYanQuanStageLog('prepare', 'start', '抖音验券预检开始', {
          requestData: {
            encryptedData: receiptCode,
            shopId: this.$store.state.shopInfo.id
          }
        });
        this.$POST1("/abutment/verify/prepare", this.$tools.getObjData({
          encryptedData: receiptCode,
          shopId: this.$store.state.shopInfo.id
        }))
            .then(res => {
              this.reportYanQuanStageLog('prepare', 'success', '抖音验券预检成功', {
                requestData: {
                  encryptedData: receiptCode,
                  shopId: this.$store.state.shopInfo.id
                },
                responseData: res
              });
              resolve(res); // 成功回传
            })
            .catch(err => {
              const isCanceled = this.isCanceledRequestError(err);
              this.reportYanQuanStageLog('prepare', isCanceled ? 'canceled' : 'fail', isCanceled ? '抖音验券预检已取消' : '抖音验券预检失败', {
                requestData: {
                  encryptedData: receiptCode,
                  shopId: this.$store.state.shopInfo.id
                },
                error: err
              });
              this.$message.error("验券失败，请稍后重试");
              reject(err); // 失败回传
            });
      });
    },
    //提交抖音验券
    submitDouYinCoupon(param) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("verifyToken", param.verifyToken);
        formData.append("encryptedCodes", param.encryptedCodes);
        formData.append("shopId", this.$store.state.shopInfo.id);
        this.reportYanQuanStageLog('verify_submit', 'start', '抖音验券提交开始', {
          requestData: {...param, shopId: this.$store.state.shopInfo.id}
        });
        this.$POST1("/abutment/verify/verify", formData)
            .then(res => {
              this.reportYanQuanStageLog('verify_submit', 'success', '抖音验券提交成功', {
                requestData: {...param, shopId: this.$store.state.shopInfo.id},
                responseData: res
              });
              this.$message.success("验券成功!");
              resolve(res);
            })
            .catch(err => {
              const isCanceled = this.isCanceledRequestError(err);
              this.reportYanQuanStageLog('verify_submit', isCanceled ? 'canceled' : 'fail', isCanceled ? '抖音验券提交已取消' : '抖音验券提交失败', {
                requestData: {...param, shopId: this.$store.state.shopInfo.id},
                error: err
              });
              const errMsg = err.msg || "验券失败，请稍后重试";
              this.$message.error(errMsg);
              reject(err);
            });
      });
    },
    //endregion

    //region 事件
    handleTimeout() {
      this.showBox = false;
      this.isClosePay = false;
      // 清除本地支付信息
      this.clearPayInfo();
    },
    //关闭支付弹窗
    handleClose() {
      if (this.status === "P" && this.isClosePay) {
        ElMessage({
          message: '支付过程中禁止关闭',
          type: 'warning',
          customClass: 'pay-message',
        });
        return;
      }
      this.showBox = false
      this.isClosePay = false
    },
    /**
     * 选择订单
     */
    confirmOrderClick(row) {
      //不能选择本订单
      if (row.id == this.formData.data.id) {
        this.$message.warning("不可以选择同一订单");
        return;
      }
      this.dialogWin.state = false;
      setTimeout(e => {
        let params = {
          key: "themeOrderEdit",
          value: {
            orderId: row.id,
            //从table里取出数据,这里的数据是table合并行的格式
            orderPlayerTableData: JSON.parse(JSON.stringify(this.$tools.getIndex(this.formData.form,
                "orderPlayerList").tableData.data)),
            type: 'orderPlayerEdit'
          }
        };
        this.$store.commit("routerParam", params);
        this.$router.push({name: 'themeOrderEdit'});
      }, 500);
      //如果处于编辑订单,把编辑关闭否则不刷新
      if (this.$store.state.currRouter.name == "themeOrderEdit") {
        this.$tools.closeCurrRouter(this.sourRouter);
      }
    },

    getContactTagList(row, item) {
      if (!row || !item) {
        return [];
      }
      const value = row[item.prop];
      if (Array.isArray(value)) {
        return value.map(tag => String(tag).trim()).filter(Boolean);
      }
      if (!value) {
        return [];
      }
      const splitReg = item.splitReg instanceof RegExp ? item.splitReg : /[,\n;\uFF0C\u3001\uFF1B]+/;
      return String(value).split(splitReg).map(tag => String(tag).trim()).filter(Boolean);
    },

    openEditContactTag(value, tagIndex, row, rowIndex, item) {
      if (!row || !item || row[item.prop + 'disabled']) {
        return;
      }
      const currentTags = this.getContactTagList(row, item);
      const initialValue = String(value || '').replace(/[^\d*]/g, '').slice(0, 11);
      const dialogPromise = ElMessageBox.prompt('', '修改联系方式', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: initialValue,
        inputType: 'tel',
        customClass: 'contact-tag-edit-dialog',
        inputValidator: (inputValue) => {
          const normalized = String(inputValue || '').replace(/[^\d*]/g, '').trim();
          if (!/^[0-9*]{1,11}$/.test(normalized)) {
            return item.tagValidateMessage || '联系方式最多输入11位';
          }
          const duplicateIndex = currentTags.findIndex((tag, index) => index !== tagIndex && tag === normalized);
          if (duplicateIndex !== -1) {
            return '该手机号已存在';
          }
          return true;
        }
      });
      this.$nextTick(() => {
        const inputEl = document.querySelector('.contact-tag-edit-dialog .el-message-box__input input');
        if (!inputEl) {
          return;
        }
        inputEl.value = initialValue;
        inputEl.setAttribute('maxlength', '11');
        inputEl.addEventListener('input', () => {
          const normalized = String(inputEl.value || '').replace(/[^\d*]/g, '').slice(0, 11);
          if (inputEl.value !== normalized) {
            inputEl.value = normalized;
          }
        }, true);
      });
      dialogPromise.then(({value: inputValue}) => {
        const normalized = String(inputValue || '').replace(/[^\d*]/g, '').trim();
        const nextTags = [...currentTags];
        nextTags.splice(tagIndex, 1, normalized);
        row[item.prop] = nextTags.join(item.separator || ',');
        if (item.change) {
          item.change(nextTags, row, rowIndex);
        }
      }).catch(() => {
      });
    },


    /**
     * 查询已有订单数据
     */
    searchOrderClick() {
      let param = JSON.parse(JSON.stringify(this.orderTableData.form));
      if (this.orderTableData.form.orderCreateTime && this.orderTableData.form.orderCreateTime.length == 2) {
        param.startTime = this.$dayjs(this.orderTableData.form.orderCreateTime[0]).format('YYYY-MM-DD');
        param.endTime = this.$dayjs(this.orderTableData.form.orderCreateTime[1]).format('YYYY-MM-DD');
        param.startSessionTime = this.$dayjs(this.orderTableData.form.orderCreateTime[0]).format('HH:mm:ss');
        param.endSessionTime = this.$dayjs(this.orderTableData.form.orderCreateTime[1]).format('HH:mm:ss');
      }
      param.orderCreateTime = "";
      param.companyId = this.$store.state.companyInfo.companyId;
      param.shopId = this.$store.state.shopInfo.id;
      param.orderType = 1;
      this.$POST("/customer/EomsOrder/selectEomsOrderByPage", param).then(res => {

        //设置订单
        for (let i = 0; i < res.data.orderList.length; i++) {

          //设置主题名称
          res.data.orderList[i].themeName = res.data.orderList[i].orderGoodsList[0].goodsName;

          //region 设置场次信息
          if (res.data.orderList[i].sessionStartTime && res.data.orderList[i].sessionEndTime) {
            res.data.orderList[i].sessionTime = res.data.orderList[i].sessionStartTime.substring(0, 5) +
                "-" + res.data.orderList[i].sessionEndTime.substring(0, 5)
          }
          //endregion

        }
        this.orderTableData.data = res.data.orderList;
        this.orderTableData.form.total = res.data.total;

      })
    },

    /**
     * 转场点击
     */
    copyOrderPlayer() {
      this.$confirm("将拼场信息转移到哪里?", {
        confirmButtonText: '新建订单',
        cancelButtonText: '已有订单',
        type: 'warning'
      }).then(() => {
        let params = {
          key: "themeOrderAdd",
          value: {
            //从table里取出数据,这里的数据是table合并行的格式
            orderPlayerTableData: JSON.parse(JSON.stringify(this.$tools.getIndex(this.formData.form,
                "orderPlayerList").tableData.data)),
            type: 'orderPlayerAdd'
          }
        };
        this.$store.commit("routerParam", params);
        this.$router.push({name: 'themeOrderAdd'});
      }).catch((e) => {
        //新建订单
        if (e == 'cancel') {
          //打开选择订单
          this.dialogWin.state = true;
          this.dialogWin.title = "请选择订单";
          this.orderTableData.form = {
            page: 1,                //页数
            limit: this.$tools.getLimit(this.$options.name), //条数
            total: 0,               //总数
            orderCreateTime: [
              this.$dayjs().format('YYYY-MM-DD') + " 00:00:00",
              this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59',
            ],
            sort: 1,
          };
          this.orderTableData.data = [];
          this.$refs.dialogWin.init(this.dialogWin, this.orderTableData);
          this.searchOrderClick();
        }
      })
    },

    /**
     * 选择会员卡客户点击
     */
    confirmCustomerClick(row) {
      const currRowId = this.dialogWin.currData.rowId;
      const orderPlayerList =
          this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      if (row.hasDraft == 1) {
        return this.$message.error("当前会员卡尚未激活，请激活后再使用！");
      }
      // 找到与 currRowId 相同的那条数据
      const targetRow = orderPlayerList.find(item => item.rowId == currRowId  && !item.customerInfo );

      if (targetRow.playerNum != null && targetRow.playerNum !== "") {
        if (targetRow.playerNum == 0) {
          return this.$message.error("请输入有效的会员卡玩家人数");
        }
        if (row.balance < this.dialogWin.currData.playerNum && row.cardType === 1) {
          return this.$message.error("余额不足，无法执行该操作");
        }
      }
      //已经把行数据赋值到currData,所以给currData赋值就是给操作行数据赋值
      this.dialogWin.currData.cardWallet = row;
      //储值卡
      if (row.cardType == 0) {
        //设置会员信息
        this.dialogWin.currData.customerInfo = row.originAccountName + "(" + row.phone + ")" +
            row.cardName + " -金币余额:" + row.balance;

        //默认金币等于应收
        this.dialogWin.currData.payAmount = this.dialogWin.currData.shouldPayAmount + "";

        //会员卡有打折权益
        if (row.benefits && row.benefits[0].discount) {
          this.dialogWin.currData.payAmount = this.$tools.accMul(this.dialogWin.currData.payAmount,
              row.benefits[0].discount).toFixed(2);
          console.log('执行的是这个吗',this.dialogWin.currData.payAmount)
          console.log('row.benefits',row.benefits)
        }
      }
      //次数卡
      if (row.cardType == 1) {
        //设置会员信息
        this.dialogWin.currData.customerInfo = row.originAccountName + "(" + row.phone + ")" +
            row.cardName + "-剩余次数:" + row.balance;

        //设置会员收款金额
        this.setPlayCounts(this.dialogWin.currData);
      }
      //关闭窗口
      this.dialogWin.state = false;
      //计算玩家总数和应收
      this.setPlayerAndPrice();
      //计算收款金额
      this.handlePayAmountByRow()
      this.setTotalPayAmount()
      //设置
      this.setTable();
    },

    /**
     * 查询客户会员卡
     */
    selectCustomerClick() {
      if (!this.customerTableData.form.phone) {
        this.$message.warning("请输入电话号码");
        return;
      }
      if (this.customerTableData.form.phone.length < 4) {
        this.$message.warning("请输入至少4位手机号码!");
        return;
      }
      this.customerTableData.form.shopId = this.$store.state.shopInfo.id;
      this.customerTableData.form.themeId = this.formData.data.themeName;
      this.$POST("/customer/EomsVip/wallet/page/np", this.customerTableData.form).then(res => {
        this.customerTableData.data = res.data.records.map(item => {
          const isSubCard = item.cardType === 1
          return {
            ...item,
            hasDraft: String(item.hasDraft),
            cishu: isSubCard ? item.balance : '-',
            jine: isSubCard ? '-' : item.balance,
          }
        });
        this.customerTableData.form.total = res.data.total;

      })
    },

    /**
     * 选择收款方式
     */
    payModeChange(e, item) {
      const previousPayMode = item.payMode;
      const originPayMode = typeof item.originPayMode === "undefined" ? previousPayMode : item.originPayMode;
      const isPersistedPayRow = !!item.orderPayId && originPayMode !== "" && originPayMode !== null && typeof originPayMode !== "undefined";
      if (isPersistedPayRow && [17, 20].includes(Number(e)) && Number(originPayMode) !== Number(e)) {
        this.$message.warning("已有收款方式不允许改为会员卡或小白盒收款!");
        item.payMode = originPayMode;
        return;
      }
      //清空会员信息
      item.cardWallet = {};
      item.customerInfo = null;
      let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      // 检查拼场中是否还有小白盒收款（payMode === 20）
      const hasHuiFuPay = orderPlayerList.some(p => p.payMode === 20);
      // 如果没有，小白盒支付按钮隐藏
      if (!hasHuiFuPay) {
        this.$tools.getIndex(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column,
            "transStat").show = false;
      }

      //选择会员卡
      if (e == 17) {
        //如果没有选择主题,不可以选择会员卡
        if (!this.formData.data.themeName) {
          this.$message.warning("请先选择主题再使用会员卡收款!");
          item.payMode = "";
          return;
        }
        let isAlone = 0;
        //判断如果会员卡不是单独一行,不可以选择会员卡
        for (let i = 0; i < orderPlayerList.length; i++) {
          if (orderPlayerList[i].rowId == item.rowId) {
            isAlone++;
          }
        }
        if (isAlone >= 2) {
          this.$message.warning("会员卡不可以与其他收款方式一起收款!");
          item.payMode = "";
          return;
        }

        //设置窗口
        this.dialogWin.state = true;
        this.dialogWin.title = "请选择消费客户";

        //把行数据赋值到currData
        this.dialogWin.currData = item;
        console.log('currData',this.dialogWin.currData)
        this.customerTableData.form = {
          page: 1,
          limit: this.$tools.getLimit(this.$options.name),
          total: 0,
          phone: "",
        };

        this.setPlayerAndPrice();
        //计算收款金额
        this.handlePayAmountByRow()
        //会员卡
        this.setTotalPayAmount()
        this.customerTableData.data = [];
        this.$refs.dialogWin.init(this.dialogWin, this.customerTableData);
      } else if (e === 20) { //如果 选择了汇付支付方式 就要显示发起支付按钮
        //所有拼场信息只能存在一个尚未支付的汇支付
        const hasUnpaidGlobal = orderPlayerList.some(
            (p) => p.payMode === 20 && (!p.bspayId || p.bspayId === "") && p.rowId !== item.rowId
        );
        //如果纯在 清空收款方式
        if (hasUnpaidGlobal) {
          this.$message.warning("请先完成汇付支付后在新增拼场");
          item.payMode = "";
          return;
        }
        //如果新增拼场 并且选择汇支付 也要进行验证
        const sameRowUnpaid = orderPlayerList.filter(
            (p) => p.rowId === item.rowId && p.payMode === 20 && (!p.bspayId || p.bspayId === "")
        );

        if (sameRowUnpaid.length > 1) {
          this.$message.warning("请先完成汇付支付后在新增拼场");
          item.payMode = "";
          return;
        }
        item.payBtn = true
        //设置支付状态
        item.transStat = "W"
        //初始等待支付
        //如果是极迅小白盒要显示支付状态表格列
        this.$tools.getIndex(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column,
            "transStat").show = true;
        //如果选择汇付收款方式 插入空microPayDTO字段
        item.microPayDTO = ''
        this.setPlayerAndPrice();
        //计算收款金额
        this.handlePayAmountByRow()
        this.setTotalPayAmount()
      }
      //重新计算金额
      else {
        //如果是其它支付方式 就要隐藏汇付支付按钮
        item.payBtn = false
        item.transStat = ""


        this.setPlayerAndPrice();
        //计算收款金额
        this.handlePayAmountByRow()
        this.setTotalPayAmount()
      }
    },

    /**
     * 增加拼场明细行 type: 0:拼场行, 1:收款行,row:收款行的行信息
     */
    addTableRow(type, row = null) {
      if (type == 1) {
        let index = 0;      //位置索引
        let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
        for (let i = 0; i < orderPlayerList.length; i++) {
          if (orderPlayerList[i].rowId == row.rowId) {
            //记录最后相等的位置索引
            index = i;
          }
        }

        //在同一拼场行最后一个位置插入新收款行
        orderPlayerList.splice(index + 1, 0, {
          playerNum: '',
          contactType: '',
          note: '',
          shouldPayAmount: '0',
          payMode: row.payMode === 20 && row.transStat === "S" ? row.payMode : '',//如果是汇付新增 ，支付方式默认为汇付
          transStat: row.payMode === 20 ? "W" : '',
          payAmount: '',
          rowId: row.rowId,
        })
      } else {
        this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data.push({
          playerNum: row ? row.playerNum : '',
          contactType: row ? row.contactType : '',
          note: row ? row.note : '',
          shouldPayAmount: row ? row.shouldPayAmount : '0',
          payMode: row ? row.payMode : '',
          // 如果有 row 则使用 row.transStat；只有当 row.payMode === 20 时 transStat 才可能为 'W'，其它场景设为空
          transStat: row ? (row.payMode === 20 ? row.transStat : '') : '',
          payAmount: row ? row.payAmount : '',
          rowId: this.$tools.getUUID(),
          boxScan: row ? row.boxScan || false : false, //校验是否为白盒扫码添加
          rowspan: row ? row.rowspan : 0,
        });

      }
      //设置收款行按钮
      this.setTable();
      //计算应收金额和玩家总数
      this.setPlayerAndPrice();
      //计算收款金额
      this.handlePayAmountByRow()
      this.setTotalPayAmount();
    },

    /**
     * 减少拼场明细行 type: 0:拼场行, 1:收款行,row:收款行的行信息
     */
    subTableRow(index) {
      const tableData = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      const removedRows = tableData.splice(index, 1);
      //设置收款行按钮
      this.setTable();
      //计算应收金额和玩家总数
      this.setPlayerAndPrice();
      //计算收款金额
      this.handlePayAmountByRow()
      this.setTotalPayAmount();
      if (removedRows.length) {
        this.reportOrderPlayerSnapshot('拼场行已删除', '删除后快照', '拼场或收款行删除后记录页面剩余拼场数据', {
          removedRows,
          removedIndex: index
        });
      }
    },

    /**
     * 选择主题
     */
    themeRadioChange(id, timeJson = '') {
      let that = this;
      return new Promise(function (resolve, reject) {
        //重置主题
        that.currTheme = {};
        //清空选择场次
        that.formData.data.sessionTime = '';
        //默认不显示加班
        that.$tools.getIndex(that.formData.form, 'orderMode').show = false;
        let timeObj = {}
        //是否有携带的时间参数
        if (timeJson) {
          timeObj = JSON.parse(timeJson)
          timeObj.time = that.$dayjs(timeObj.time).format('YYYY-MM-DD HH:mm:ss');
          that.formData.data.orderCreateTime = that.$dayjs(timeObj.time).format('YYYY-MM-DD');
        }
        //查询主题详情
        let param = {
          id: id,
          createOrderDate: that.$dayjs(that.formData.data.orderCreateTime).format("YYYY-MM-DD"),
        };
        that.$POST1("/customer/EomsTheme/getEomsThemeById", param).then(res => {
          that.currTheme = res.data;
          that.formData.data.themePrice = res.data.price;
          //region 设置岗位
          //移除原来的岗位
          for (let i = 0; i < that.formData.form.length; i++) {
            if (that.formData.form[i].prop.indexOf('themeJob_') != -1) {
              that.formData.form.splice(i, 1);
              i--;
            }
          }
          //设置选择主题的岗位
          that.$tools.getIndex(that.formData.form, 'job').show = false;
          if (that.currTheme.themeJobList && that.currTheme.themeJobList.length > 0) {
            //循环岗位设置Form
            for (let k = 0; k < that.currTheme.themeJobList.length; k++) {
              that.formData.form.push({
                label: that.currTheme.themeJobList[k].jobName,
                labelWidth: 100,
                prop: 'themeJob_' + that.currTheme.themeJobList[k].id,
                type: 'select',
                multiple: true,
                sourceList: that.shopStaffList,
                sourceProp: {text: 'note', value: 'eomsUserId'},
              });
              //设置默认数据
              that.formData.data['themeJob_' + that.currTheme.themeJobList[k].id] = [];
              //判断是否有加班选项
              if (that.currTheme.themeJobList[k] && that.currTheme.themeJobList[k].themeJobOverwork) {
                that.$tools.getIndex(that.formData.form, 'orderMode').show = true;
                that.formData.data.orderMode = "1"
              }
            }
            that.$tools.getIndex(that.formData.form, 'job').show = true;
          }
          //endregion
          //region 设置场次信息
          for (let i = 0; i < that.currTheme.themeSessionList.length; i++) {
            //判断是否是次日
            let businessHoursStart = that.$dayjs("2023-01-01 " + that.currTheme.businessHoursStart);
            let startTime = that.$dayjs("2023-01-01 " + that.currTheme.themeSessionList[i].startTime);
            //次日
            if (that.$dayjs(startTime).isBefore(businessHoursStart)) {
              that.currTheme.themeSessionList[i].sessionTime =
                  "次日" + that.currTheme.themeSessionList[i].startTime + "-" +
                  that.currTheme.themeSessionList[i].endTime;
              that.currTheme.themeSessionList[i].sessionTimeText =
                  "次日" + that.currTheme.themeSessionList[i].startTime.substring(0, 5) + "-" +
                  that.currTheme.themeSessionList[i].endTime.substring(0, 5);
              that.currTheme.themeSessionList[i].isTomorrow = true;
              that.currTheme.themeSessionList[i].date =
                  that.$dayjs(that.formData.data.orderCreateTime).add(1, "day").format("YYYY-MM-DD");
            }
            //今日
            else {
              that.currTheme.themeSessionList[i].sessionTime =
                  that.currTheme.themeSessionList[i].startTime + "-" +
                  that.currTheme.themeSessionList[i].endTime;
              that.currTheme.themeSessionList[i].sessionTimeText =
                  that.currTheme.themeSessionList[i].startTime.substring(0, 5) + "-" +
                  that.currTheme.themeSessionList[i].endTime.substring(0, 5);
              that.currTheme.themeSessionList[i].isTomorrow = false;
              that.currTheme.themeSessionList[i].date =
                  that.$dayjs(that.formData.data.orderCreateTime).format("YYYY-MM-DD");
            }
          }
          //判断场次是否占用
          let orderList = Array.isArray(res.data.orderList) ? res.data.orderList : [];
          let themeSessionList = Array.isArray(that.currTheme.themeSessionList) ? that.currTheme.themeSessionList : [];
          const currentOrderId = that.formData.data.id
          for (let j = 0; j < themeSessionList.length; j++) {
            themeSessionList[j].disabled = false
          }
          for (let i = 0; i < orderList.length; i++) {
            for (let j = 0; j < themeSessionList.length; j++) {
              const isSameSlot =
                  orderList[i].goodsId == themeSessionList[j].themeId &&
                  orderList[i].orderCreateTime == themeSessionList[j].date &&
                  orderList[i].sessionStartTime == themeSessionList[j].startTime &&
                  orderList[i].sessionEndTime == themeSessionList[j].endTime
              const isCurrentOrder = currentOrderId
                  ? orderList[i].id == currentOrderId
                  : (
                      orderList[i].goodsId == themeSessionList[j].themeId &&
                      orderList[i].orderCreateTime == that.formData.data.orderCreateTime &&
                      orderList[i].sessionStartTime == that.formData.data.sessionStartTime &&
                      orderList[i].sessionEndTime == that.formData.data.sessionEndTime
                  )
              if (isSameSlot && !isCurrentOrder) {
                themeSessionList[j].disabled = true
              }
            }
          }

          const now = that.$dayjs()

          //设置场次数据
          //渲染颜色
          const selectedTime = `${that.formData.data.orderCreateTime} ${that.formData.data.sessionStartTime}-${that.formData.data.sessionEndTime}`
          that.$tools.getIndex(that.formData.form, 'sessionTime').sourceList =
              themeSessionList.map(item => {
                const start = that.$dayjs(`${item.date} ${item.startTime}`)
                let originBorderColor = '#dcdfe6' // 默认未开始
                if (now.isAfter(start)) {
                  originBorderColor = '#F8F9FA' // 已开始
                }
                // 渲染颜色
                let borderColor = originBorderColor
                if (`${item.date} ${item.startTime}-${item.endTime}` === selectedTime) {
                  borderColor = '#409EFF' // 高亮选中
                }
                return {
                  ...item,
                  originBorderColor, // 保存原始颜色
                  style: {
                    borderColor,
                    marginBottom: '10px'
                  }
                }
              })

          if(that.formData.data.sessionStartTime && that.formData.data.sessionEndTime){
            that.formData.data.sessionTime = `${that.formData.data.sessionStartTime}-${that.formData.data.sessionEndTime}`
          }
          //region 从首页排场进入要渲染对应日期的场次
          if (timeJson) {
            //获取最近时间的场次数据
            const findNearestTime = (targetTime, timeList) => {
              const target = that.$dayjs(targetTime)
              let nearest = null
              let minDiff = Infinity
              for (const item of timeList) {
                let time = `${item.date} ${item.startTime}`;
                const diff = Math.abs(that.$dayjs(time).diff(target, 'millisecond'))
                if (diff < minDiff && !item.disabled) {
                  minDiff = diff
                  nearest = item
                }
              }
              return nearest
            }
            const result = findNearestTime(timeObj.time, themeSessionList)
            // 选中跳转携带的时间
            that.formData.data.sessionTime = result.sessionTime
            that.$tools.getIndex(that.formData.form, 'sessionTime').sourceList = that.$tools.getIndex(that.formData.form, 'sessionTime').sourceList.map(item => {
              const isSelected = result.sessionTime === item.sessionTime;
              return {
                ...item,
                style: {
                  // 高亮选中项为蓝色，其余保持原始颜色
                  borderColor: isSelected ? '#409EFF' : item.originBorderColor || '#dcdfe6',
                  marginBottom: '10px'
                }
              }
            })
          }
          //endregion

          //endregion
          //region 计算金额
          that.setPlayerAndPrice();
          //endregion

          //region 计算收款金额
          that.handlePayAmountByRow()
          //endregion
          //region 计算实收
          that.setTotalPayAmount();
          //endregion
          resolve();
        });

      });
    },
    /**
     * 按钮点击
     */
    btnClick(e) {
      switch (e) {
        case 'save':
          this.$refs.formData.submit().then(res => {
            console.log('执行这个了吗123save')
            this.save();
          });
          break;
          //endregion
          //region 返回
        case 'back':
          this.$tools.closeCurrRouter(this.sourRouter);
          break;
          //endregion
          //region 暂存
        case 'zancun':
          let data = {
            formData: this.formData.data,
            orderPlayerList: this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data,
          };
          localStorage.setItem("temp_themeOrderAdd", JSON.stringify(data));
          this.$message.success("已暂时保存数据,下次打开自动填写!");
          break;
          //endregion
          //region 清空
        case 'clear':
          // 获取拼场表格数据
          let orderPlayerList = JSON.parse(JSON.stringify(
              this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data
          ));
          if (orderPlayerList.some(player => player.payMode === 20 && player.bspayId)) {
            return this.$message.warning('当前订单包含已支付的汇付订单，禁止清空!');
          }
          this.initFormData();
          localStorage.removeItem("temp_themeOrderAdd");
          this.$message.success("已重置所有数据!");
          break;
          //endregion
      }
    },
    //region 最后表单提交

    save() {
      //如果拼场信息中有一笔 汇付收款方式并且是未支付状态 禁止新增拼场
      if (!this.validatePay()) return false
      let param = this.buildParams();          // 生成参数
      param = this.validateParams(param);      // 校验参数
      if (!param) return;                      // 校验失败
      this.reportOrderPlayerSnapshot('普通保存提交前拼场快照', '准备保存', '普通保存订单前记录当前页面拼场和提交拼场', {
        submitOrderPlayerList: param.orderPlayerList || []
      });
      this.handleDiffExplanation(param);       // 差额说明再进入提交
    },
    //endregion

    //region 生成提交参数
    buildParams() {
      let param = JSON.parse(JSON.stringify(this.formData.data));
      const currTheme = this.currTheme || {};
      //设置商品中岗位信息
      let orderGoodsJobList = [];
      if (currTheme.themeJobList && currTheme.themeJobList.length > 0) {
        for (let k = 0; k < currTheme.themeJobList.length; k++) {
          //设置岗位信息里的人员信息集合
          let orderGoodsJobUserList = [];
          //岗位有选择员工,循环放到上面集合里
          let arr = param["themeJob_" + currTheme.themeJobList[k].id];
          if (arr && arr.length > 0) {
            //循环已选择选择的人员
            for (let j = 0; j < arr.length; j++) {
              orderGoodsJobUserList.push({
                eomsUserId: arr[j]
              })
            }
          }
          orderGoodsJobList.push({
            jobId: currTheme.themeJobList[k].id,
            jobName: currTheme.themeJobList[k].jobName,
            jobNo: currTheme.themeJobList[k].jobNo,
            orderGoodsJobUserList: orderGoodsJobUserList,
          })
        }
      }else{
        //如果没有岗位信息那么证明它的订单种类一定是普通订单
        param.orderMode = "1"
      }
      //设置商品集合
      param.orderGoodsList = [{
        goodsCount: 1,
        goodsId: currTheme.id || '',
        goodsType: 1,
        singlePrice: this.formData.data.themePrice,
        orderGoodsJobList: orderGoodsJobList
      }];

      //region 设置拼场信息
      //校验拼场信息,从table取出数据,处理成保存的格式
      let orderPlayerList = JSON.parse(JSON.stringify(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data));
      //设置数据
      let list = [];
      //取出拼场信息
      for (let i = 0; i < orderPlayerList.length; i++) {
        if (orderPlayerList[i].rowspan > 0) {
          list.push(orderPlayerList[i]);
        }
      }
      //设置收款信息
      for (let k = 0; k < list.length; k++) {
        list[k].orderPays = [];
        for (let i = 0; i < orderPlayerList.length; i++) {
          orderPlayerList[i].id = orderPlayerList[i].orderPlayerId;
          if (orderPlayerList[i].rowId == list[k].rowId) {
            let item = {
              cardWallet: orderPlayerList[i].cardWallet,
              payMode: orderPlayerList[i].payMode,
              payAmount: orderPlayerList[i].payAmount,
              id: orderPlayerList[i].orderPayId ? orderPlayerList[i].orderPayId : '',
              orderPlayerId: orderPlayerList[i].orderPlayerId ? orderPlayerList[i].orderPlayerId : '',
              microPayDTO: {
                authCode: orderPlayerList[i].authCode
              },
              bspayId: orderPlayerList[i].bspayId,//支付状态
              transStat: orderPlayerList[i].transStat,//支付状态
              payCoins: orderPlayerList[i].payAmount
            };
            //次卡会员把收款金额改回数字
            if (item.cardWallet && item.cardWallet.cardType == 1 && item.payAmount && item.payAmount.indexOf("(") >= -1) {
              item.payAmount = item.payAmount.split("(")[0];
              item.payCoins = item.payAmount

            }

            list[k].orderPays.push(item);
          }
        }
      }
      param.orderPlayerList = list;
      param.orderPayList = null;
      //endregion

      //region 设置场次时间
      //次日
      if (!param.sessionTime) {
        param.sessionStartTime = '';
        param.sessionEndTime = '';
      } else if (param.sessionTime.indexOf("次日") != -1) {
        //设置场次
        let arr = param.sessionTime.split("-");
        param.sessionStartTime = arr[0].replace("次日", "");
        param.sessionEndTime = arr[1];
        //设置下单日期
        param.orderCreateTime = this.$dayjs(param.orderCreateTime).add(1, 'day').format('YYYY-MM-DD');
      } else {
        //设置场次
        let arr = param.sessionTime.split("-");
        param.sessionStartTime = arr[0];
        param.sessionEndTime = arr[1];
        //设置下单日期
        param.orderCreateTime = this.$dayjs(param.orderCreateTime).format('YYYY-MM-DD');
      }
      //endregion

      //字符串来源
      if (param.orderSource && param.orderSource.length > 0) {
        param.orderSource = param.orderSource.join(",");
      } else {
        param.orderSource = ""
      }
      //字符串客群
      if (param.customerType && param.customerType.length > 0) {
        param.customerType = param.customerType.join(",");
      } else {
        param.customerType = 0;
      }
      //加班模式
      if (!param.orderMode) {
        param.orderMode = 1;
      }
      //设置其他信息
      param.shopId = this.$store.state.shopInfo.id;
      param.orderType = 1;
      return param;
    },
    //endregion

    //region 差额说明
    handleDiffExplanation(param) {
      if (param.orderPriceDiffs === '1' && param.totalPayAmount < param.totalReceivePrice) {
        ElMessageBox({
          title: '',
          showTitle: false,
          customClass: 'my-message-box',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          message: () =>
              h('div', {style: 'display:flex; flex-direction:column; gap:16px;width:auto'}, [
                // 标题
                h('div', {style: 'font-weight: bold;'}, '请填写实收小于应收的原因:'),
                // 差额原因多选框
                h(
                    ElCheckboxGroup,
                    {
                      modelValue: this.checkedTypes.map(i => i.id),
                      'onUpdate:modelValue': (vals) => {
                        this.checkedTypes = this.shopDiffPriceNoticeList
                            .filter(item => vals.includes(item.id))
                            .map(({value, id}) => ({value, id}));
                      },
                      style: `
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  gap: 12px 16px;
                `
                    },
                    () =>
                        this.shopDiffPriceNoticeList.map(item =>
                            h(
                                ElCheckbox,
                                {value: item.id, border: true, style: 'width: 100%; text-align: center;'},
                                () => item.value
                            )
                        )
                ),
                // 其它原因输入框
                h('div', {style: 'font-weight: bold;'}, '其它原因：'),
                h(ElInput, {
                  modelValue: this.orderPriceDiffNoticesInput,
                  type: "textarea",
                  rows: 3,
                  maxlength: 50,      // 最多输入50字
                  showWordLimit: true,
                  placeholder: '请输入内容',
                  'onUpdate:modelValue': (val) => {
                    this.orderPriceDiffNoticesInput = val
                  }
                })
              ]),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              // 必须至少选择一个差额原因
              if (!this.checkedTypes.length) {
                this.$message.warning('请选择差额原因')
                return
              }
              // 整合原因（复选框 + 手动输入）
              const result = [
                ...this.checkedTypes,
                {value: this.orderPriceDiffNoticesInput}
              ];
              param.orderPriceDiffNoticesJsonStr = JSON.stringify(result);

              // 提交订单
              this.saveOrder(param);
            }
            done();
          }
        });
      } else {
        // 不需要差额说明，直接提交
        this.saveOrder(param);
      }
    },
    //endregion
    //region 接口提交
    /**
     * 保存订单（新增 / 修改）
     * @param {Object} param - 提交的参数
     * @param {Object} options - 可选参数
     * @param {Boolean} options.backOnSuccess - 是否保存成功后返回上一页（默认 true）
     * @param {Function} options.onSuccess - 自定义成功回调（优先级高于 backOnSuccess）
     */
    saveOrder(param, options = {}) {
      const isUpdate = !!param.id;
      const url = isUpdate
          ? "/customer/EomsOrder/updateEomsOrder"
          : "/customer/EomsOrder/insertEomsOrder";
      if (this.shouldReportYanQuanFlow()) {
        this.reportYanQuanStageLog('order_save', 'start', isUpdate ? 'order update start' : 'order create start', {
          saveApi: url,
          requestData: {
            id: param.id || '',
            orderCode: param.orderCode || '',
            orderPlayerCount: Array.isArray(param.orderPlayerList) ? param.orderPlayerList.length : 0,
            submittedOrderPlayerList: param.orderPlayerList || []
          }
        });
      }
      const successMsg = isUpdate ? "修改成功!" : "创建成功!";
      return this.$POST(url, this.$tools.getObjData(param), true, "loading...", true, !isUpdate)
          .then(async res => {
            if (this.shouldReportYanQuanFlow()) {
              await this.reportYanQuanStageLog('order_save', 'success', isUpdate ? 'order update success' : 'order create success', {
                saveApi: url,
                requestData: {
                  id: param.id || '',
                  orderCode: param.orderCode || '',
                  orderPlayerCount: Array.isArray(param.orderPlayerList) ? param.orderPlayerList.length : 0,
                  submittedOrderPlayerList: param.orderPlayerList || []
                },
                responseData: res
              });
            }
            this.$message.success(successMsg);
            // 如果定义了自定义回调 → 优先执行
            // 支持外部等待保存后的异步动作执行完，比如验券后的自动绑券。
            if (typeof options.onSuccess === "function") {
              await options.onSuccess(res);
              return res;
            }

            // 修改成功
            if (isUpdate) {
              if (options.backOnSuccess !== false) {
                this.btnClick("back"); // 默认返回上一页
              }
            } else {
              if (options.backOnSuccess !== false) {
                this.btnClick("back"); // 默认返回上一页
              }
            }
            return res;
          })
          .catch(async err => {
            if (this.shouldReportYanQuanFlow()) {
              const isCanceled = this.isCanceledRequestError(err);
              await this.reportYanQuanStageLog('order_save', isCanceled ? 'canceled' : 'fail', isCanceled ? 'order save canceled' : 'order save fail', {
                saveApi: url,
                requestData: {
                  id: param.id || '',
                  orderCode: param.orderCode || '',
                  orderPlayerCount: Array.isArray(param.orderPlayerList) ? param.orderPlayerList.length : 0,
                  submittedOrderPlayerList: param.orderPlayerList || []
                },
                error: err
              });
            }
            this.isClosePay = false
            if (isUpdate && await this.$tools.handleOrderUpdateException(err, {
              onRefresh: async () => {
                this.closeOrderUpdateDialogs();
                await this.getOrderInfo(param.id);
              },
              onBack: () => this.btnClick("back"),
            })) {
              return;
            }
            if (options.throwOnError) {
              throw err;
            }
            console.log('err',err)
            this.$message.error(isUpdate ? err.msg : err.msg);

          });
    },
    //endregion

    //region 参数校验
    /**
     * 校验并整理拼场信息
     * 主要检查收款信息、人数信息是否完整，并组装 orderPlayerList
     */
    validateParams(param) {
      // 获取拼场表格数据
      let orderPlayerList = JSON.parse(JSON.stringify(
          this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data
      ));
      if (!this.formData.data.themeName) {
        this.reportOrderValidateFailure('缺少主题', '保存参数校验失败：未选择主题', {
          failureType: 'missing_themeName',
          submitParamSnapshot: param || {},
          tableRowsBeforeValidate: orderPlayerList
        });
        this.$message.warning(`请选择主题!`);
        return false
      }

      if (!this.formData.data.sessionTime) {
        this.reportOrderValidateFailure('缺少场次', '保存参数校验失败：未选择场次时间', {
          failureType: 'missing_sessionTime',
          submitParamSnapshot: param || {},
          tableRowsBeforeValidate: orderPlayerList
        });
        this.$message.warning(`请选择场次时间!`);
        return false
      }
      //校验拼场信息
      for (let i = 0; i < orderPlayerList.length; i++) {
        const row = orderPlayerList[i];
        // 整行收款金额、收款方式、人数都为空，且 rowspan>0，直接删除
        if (!row.payAmount && !row.payMode && (!row.playerNum && row.rowspan > 0)) {
          this.reportYanQuanStageLog('拼场提交校验', '自动剔除空拼场行', '保存参数校验时发现空拼场行，自动从提交参数中剔除', {
            removedRow: row,
            rowIndex: i,
            beforeValidateSnapshot: this.getOrderPlayerSnapshot(orderPlayerList)
          });
          orderPlayerList.splice(i, 1);
          i--;
          continue;
        }

        // 如果填写了收款方式，则 payAmount 必须填写
        if (row.payMode && (row.payAmount === null || row.payAmount === undefined || row.payAmount === "")) {
          this.reportOrderValidateFailure('缺少收款金额', `保存参数校验失败：第 ${i + 1} 行有收款方式但缺少收款金额`, {
            failureType: 'missing_payAmount',
            rowIndex: i,
            failedRow: row,
            fieldStatus: {
              payMode: row.payMode,
              payAmount: row.payAmount,
              playerNum: row.playerNum,
              rowId: row.rowId || '',
              rowspan: row.rowspan,
              boxScan: !!row.boxScan
            },
            tableRowsBeforeValidate: orderPlayerList
          });
          this.$message.warning(`请补全第 ${i + 1} 行收款金额!`);
          return null;
        }
        // 如果填写了收款金额，则 payMode 必须填写
        if (row.payAmount && !row.payMode) {
          this.reportOrderValidateFailure('缺少收款方式', `保存参数校验失败：第 ${i + 1} 行有收款金额但缺少收款方式`, {
            failureType: 'missing_payMode',
            rowIndex: i,
            failedRow: row,
            fieldStatus: {
              payMode: row.payMode,
              payAmount: row.payAmount,
              playerNum: row.playerNum,
              rowId: row.rowId || '',
              rowspan: row.rowspan,
              boxScan: !!row.boxScan
            },
            tableRowsBeforeValidate: orderPlayerList
          });
          this.$message.warning(`请补全第 ${i + 1} 行收款方式!`);
          return null;
        }
        // 如果填写了收款方式或收款金额，则人数必填 如果是验券填写就跳过这条校验
        if ((row.payMode || row.payAmount) && (!row.playerNum  && row.playerNum != '0' && row.rowspan > 0) && !(this.yanQuanConfig && this.yanQuanConfig.visible)) {

          this.reportOrderValidateFailure('缺少拼场人数', `保存参数校验失败：第 ${i + 1} 行有收款信息但缺少人数`, {
            failureType: 'missing_playerNum',
            rowIndex: i,
            failedRow: row,
            fieldStatus: {
              payMode: row.payMode,
              payAmount: row.payAmount,
              playerNum: row.playerNum,
              rowId: row.rowId || '',
              rowspan: row.rowspan,
              boxScan: !!row.boxScan,
              yanQuanVisible: !!(this.yanQuanConfig && this.yanQuanConfig.visible)
            },
            tableRowsBeforeValidate: orderPlayerList
          });
          this.$message.warning(`请补全第 ${i + 1} 行人数!`);
          return null;
        }

      }

      // 组装拼场信息
      let list = orderPlayerList.filter(item => item.rowspan > 0);
      for (let row of list) {
        row.orderPays = [];
        for (let item of orderPlayerList) {
          item.id = item.orderPlayerId;
          // 如果id相等，并且有收款方式才进行数据拼接
          if (item.rowId == row.rowId && item.payMode) {
            // 收款项
            let payItem = {
              cardWallet: item.cardWallet,
              payMode: item.payMode,
              payAmount: item.payAmount,
              id: item.orderPayId || '',
              orderPlayerId: item.orderPlayerId || '',
              bspayId: item.bspayId || null,
              transStat: item.transStat || null,
              payCoins: item.payAmount
            };
            // 次卡会员：把金额里的“(xx次)”去掉，只保留数字
            if (payItem.cardWallet && payItem.cardWallet.cardType == 1 &&
                payItem.payAmount && payItem.payAmount.includes("(")) {
              payItem.payAmount = payItem.payAmount.split("(")[0];
              payItem.payCoins = payItem.payAmount
            }
            row.orderPays.push(payItem);
          }
        }
      }
      // 设置到参数里
      param.orderPlayerList = list;
      param.orderPayList = null;

      return param;
    },
    //endregion

    //region 订单绑定验券
    /**
     * 订单绑定验劵
     */
    // 顺序绑定整批券，单张失败先记录并继续后续券，整批结束后再补绑失败券。
    async bindOrderSafe(list, orderId, index = 0, options = {}) {
      const safeList = Array.isArray(list) ? list : [];
      let successCount = 0;
      let skipCount = 0;
      const firstFailures = [];
      const finalFailures = [];
      await this.reportBindOrderLog({
        status: 'start',
        message: 'batch bind start',
        bindInfo: {
          orderId,
          runMode: options.runMode || '正常绑券',
          bindIndex: index,
          bindTotal: safeList.length
        }
      });

      if (!safeList.length) {
        await this.reportBindOrderLog({
          status: 'skip',
          message: 'batch bind skipped: empty ticket list',
          bindInfo: {
            orderId,
            runMode: options.runMode || '正常绑券',
            bindIndex: index,
            bindTotal: 0
          }
        });
        return {
          success: true,
          empty: true,
          bindTotal: 0,
          successCount: 0,
          skipCount: 0
        };
      }

      const buildFailureInfo = (failure) => {
        const item = failure.item || {};
        const error = failure.error || {};
        const ticket = error.bindTicket || item;
        const bindErrorInfo = this.classifyBindOrderError(error);
        return {
          index: failure.index,
          item,
          error,
          ticket,
          errorType: bindErrorInfo.errorType,
          errorReason: bindErrorInfo.errorReason,
          requestData: error.bindRequestData || null,
          responseData: error.bindResponseData || this.getBindOrderSnapshot(this.getBindOrderErrorResponse(error)),
          responseStatus: this.getBindOrderErrorStatus(error),
          label: ticket.goodsName || ticket.receiptCode || `第${failure.index + 1}张券`
        };
      };

      const bindOne = async (item, itemIndex, pass) => {
        try {
          const bindResult = await this.bindOrderWithRetry(item, orderId, itemIndex, options);
          if (bindResult && bindResult.skipped) {
            skipCount++;
          } else {
            successCount++;
          }
          return null;
        } catch (err) {
          const bindErrorInfo = this.classifyBindOrderError(err);
          const ticket = err.bindTicket || item || {};
          await this.reportBindOrderLog({
            status: pass === 'retry' ? 'retry_fail' : 'deferred_fail',
            message: pass === 'retry' ? '券码补绑失败' : '券码绑定失败，已记录待补绑',
            errorType: bindErrorInfo.errorType,
            errorReason: bindErrorInfo.errorReason,
            requestData: err.bindRequestData || this.getBindOrderSnapshot(item),
            responseData: err.bindResponseData || this.getBindOrderSnapshot(this.getBindOrderErrorResponse(err)),
            responseStatus: this.getBindOrderErrorStatus(err),
            bindInfo: {
              orderId,
              runMode: options.runMode || '正常绑券',
              bindIndex: itemIndex,
              bindPass: pass,
              goodsName: ticket.goodsName || '',
              type: ticket.type || '',
              receiptCode: ticket.receiptCode || '',
              verifyId: ticket.verifyId || ''
            },
            error: err
          });
          return {
            item,
            index: itemIndex,
            error: err
          };
        }
      };

      for (let i = index; i < safeList.length; i++) {
        if (!safeList[i]) continue;
        const failure = await bindOne(safeList[i], i, 'first');
        if (failure) {
          firstFailures.push(failure);
        }
      }

      if (firstFailures.length) {
        await this.reportBindOrderLog({
          status: 'retrying',
          message: 'batch bind retry start',
          bindInfo: {
            orderId,
            runMode: options.runMode || '正常绑券',
            bindTotal: safeList.length,
            failedTotal: firstFailures.length,
            failedTickets: firstFailures.map(buildFailureInfo).map(item => ({
              bindIndex: item.index,
              goodsName: item.ticket.goodsName || '',
              type: item.ticket.type || '',
              receiptCode: item.ticket.receiptCode || '',
              verifyId: item.ticket.verifyId || '',
              errorType: item.errorType,
              errorReason: item.errorReason,
              requestData: item.requestData,
              responseData: item.responseData,
              responseStatus: item.responseStatus
            }))
          }
        });

        for (const failure of firstFailures) {
          const retryFailure = await bindOne(failure.item, failure.index, 'retry');
          if (retryFailure) {
            finalFailures.push(retryFailure);
          }
        }
      }

      if (finalFailures.length) {
        const failedInfos = finalFailures.map(buildFailureInfo);
        const failedLabels = failedInfos.map(item => item.label).slice(0, 3).join('、');
        const suffix = failedInfos.length > 3 ? '等' : '';
        await this.reportBindOrderLog({
          status: 'partial_fail',
          message: 'batch bind partial fail',
          bindInfo: {
            orderId,
            runMode: options.runMode || '正常绑券',
            bindTotal: safeList.length,
            successCount,
            skipCount,
            failedTotal: finalFailures.length,
            failedTickets: failedInfos.map(item => ({
              bindIndex: item.index,
              goodsName: item.ticket.goodsName || '',
              type: item.ticket.type || '',
              receiptCode: item.ticket.receiptCode || '',
              verifyId: item.ticket.verifyId || '',
              errorType: item.errorType,
              errorReason: item.errorReason,
              requestData: item.requestData,
              responseData: item.responseData,
              responseStatus: item.responseStatus
            }))
          },
          error: finalFailures[0].error
        });
        if (!options.silent) {
          this.$message.error(`券码绑定完成，${successCount}张成功，${skipCount}张跳过，${finalFailures.length}张补绑失败：${failedLabels}${suffix}，请稍后重试`);
        }
        return {
          success: false,
          error: finalFailures[0].error,
          failedIndex: finalFailures[0].index,
          failedItems: finalFailures,
          successCount,
          skipCount
        };
      }

      if (!options.silent) {
        this.$message.success("券码绑定成功!");
      }
      await this.reportBindOrderLog({
        status: 'success',
        message: 'batch bind success',
        bindInfo: {
          orderId,
          runMode: options.runMode || '正常绑券',
          bindIndex: index,
          bindTotal: safeList.length,
          successCount,
          skipCount,
          firstFailRetryCount: firstFailures.length
        }
      });
      const routerParam = this.$store.getters.getRouterParam;
      if (!options.silent && routerParam && routerParam.type === 'verifyCodeAdd') {
        this.btnClick("back");
      }
      return {
        success: true,
        bindTotal: safeList.length,
        successCount,
        skipCount,
        firstFailRetryCount: firstFailures.length
      };
    },
    bindOrder(list, orderId, index = 0) {
      return new Promise((resolve, reject) => {
        const next = (i) => {
          if (i < list.length && list[i]) {
            let param = {
              ...list[i],
              operation: 1,
              orderId,
              verifyId: list[i].verifyId || ''
            };

            let request =
                param.type === "美团"
                    ? this.$POST1(
                        "/abutment/groupPurchase/connectOrUnConnectOrder",
                        this.$tools.getObjData(param)
                    )
                    : this.$POST1(
                        "/abutment/verify/connectOrUnConnectOrder",
                        this.$tools.getObjData(param)
                    );

            request
                .then(() => {
                  param.isNew = false;
                  const boundItem = (this.yanQuanConfig && this.yanQuanConfig.verifyCodeArr || []).find(v => v.verifyId === param.verifyId);
                  if (boundItem) boundItem.isCodeNew = false;
                  next(i + 1);
                })
                .catch(err => reject(err));
          } else {
            this.$message.success("券码绑定成功!");
            const routerParam = this.$store.getters.getRouterParam;
            if (routerParam && routerParam.type === 'verifyCodeAdd') {
              this.btnClick("back");
            }
            resolve();
          }
        };

        next(index);
      });
    },

    //endregion

    //region 获取抖音验券列表


    //endregion

    //region 设置拼场信息

    /**
     * 合并单元格
     */
    tableSpanMethod(row, column, rowIndex, columnIndex) {
      //只合并前几列,收款信息几列不合并
      if (columnIndex < this.columnCount) {
        let orderPlayerList = this.$tools.getIndex(this.formData.form, 'orderPlayerList').tableData.data;
        let spanCount = 0;      //向下合并的行数
        let tempRow = [];       //临时储存合并行的数据
        //循环判断
        for (let i = 0; i < orderPlayerList.length; i++) {
          //rowId相同表示是同一行,需要合并
          if (orderPlayerList[i].rowId == row.rowId) {
            spanCount++;
            tempRow.push(orderPlayerList[i])
          }
        }
        //如果有多行,进行合并
        if (tempRow.length > 0) {
          for (let i = 0; i < tempRow.length; i++) {
            //第一行向下合并, spanCount即是向下合并的行数
            if (i == 0) {
              tempRow[i].rowspan = spanCount;
            }
            //其他被合并行,默认rowspan等于0
            else {
              tempRow[i].rowspan = 0;
            }
          }
          return {
            rowspan: row.rowspan,
            colspan: 1
          }
        }
      }

    },

    /**
     * 设置表格
     */
    setTable() {
      let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      //收款行按钮设置
      for (let i = 0; i < orderPlayerList.length; i++) {
        let tempList = [];
        let tempId = orderPlayerList[i].rowId;
        //相同拼场行
        for (let k = 0; k < orderPlayerList.length; k++) {
          if (tempId == orderPlayerList[k].rowId) {
            tempList.push(orderPlayerList[k]);
          }
        }
        //设置同拼场行收款的按钮
        for (let a = 0; a < tempList.length; a++) {
          tempList[a].jianBtn = true;
          tempList[a].jiaBtn = false;

          if (tempList[a].payMode === 20) {
            tempList[a].payBtn = true;
          } else {
            tempList[a].payBtn = false;
          }
        }
        //默认第一行不可以删除收款
        tempList[0].jianBtn = false;

        //默认最后一行可以增加收款
        tempList[tempList.length - 1].jiaBtn = true;
      }

      //特殊行设置
      for (let a = 0; a < orderPlayerList.length; a++) {

        //会员卡,
        if (orderPlayerList[a].cardWallet && orderPlayerList[a].cardWallet.cardId) {
          //次数卡金额不可以输入
          if (orderPlayerList[a].cardWallet.cardType == 1) {
            orderPlayerList[a].payAmountdisabled = true;
          }
          //不可新增
          orderPlayerList[a].jianBtn = false;
          orderPlayerList[a].jiaBtn = false;
          //有一个会员信息就要显示会员信息列
          this.$tools.getIndex(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column,
              "customerInfo").show = true;
        } else
            //没有会员信息,收款方式是会员,则清空收款方式
        if (orderPlayerList[a].payMode == 17) {
          orderPlayerList[a].payMode = "";

        } else
            //如果是汇付收款方式並且支付成功需要禁止用户修改和操作
        if (orderPlayerList[a].payMode === 20 && orderPlayerList[a].bspayId && orderPlayerList[a].transStat === "S") {
          //禁用收款金额
          orderPlayerList[a].payAmountdisabled = true;
          //禁用收款方式
          orderPlayerList[a].payModedisabled = true;
          //禁用删除按钮
          orderPlayerList[a].jianBtn = false;
          //禁用支付按钮
          orderPlayerList[a].payBtn = false;
          this.$tools.getIndex(this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column,
              "transStat").show = true;
          //region 校验惠付支付 如果开单过程中有汇付支付并且支付成功就要显示退款按钮
          // this.$tools.getIndex(this.formData.form, 'button').diy5.show = true
          //endregion
        }
        //如果有退款(有退款一定是编辑)
        if (orderPlayerList[a].tuiAmountStr) {
          //同退款行的所有行不可以修改
          for (let j = 0; j < orderPlayerList.length; j++) {
            if (orderPlayerList[j].rowId == orderPlayerList[a].rowId) {
              //不可修改金额和收款方式
              orderPlayerList[j].payModedisabled = true;
              orderPlayerList[j].payAmountdisabled = true;
              //行不可以被删除
              orderPlayerList[j].playerNumBtn = false;
              orderPlayerList[j].playerNumdisabled = true;
              //行不可新增减少
              orderPlayerList[j].jianBtn = false;
              orderPlayerList[j].jiaBtn = false;
            }
          }
        }
        //如果是编辑,会员卡所有信息不可修改
        if (orderPlayerList[a].cardWallet && orderPlayerList[a].cardWallet.cardWalletId && orderPlayerList[a].orderPayId) {
          //其他行也不可以修改
          for (let j = 0; j < orderPlayerList.length; j++) {
            if (orderPlayerList[j].rowId == orderPlayerList[a].rowId) {
              //不可修改金额和收款方式,次数
              orderPlayerList[j].payModedisabled = true;
              // orderPlayerList[j].payAmountdisabled = true; //修改成可以编辑金额
              //行不可以被删除
              orderPlayerList[j].playerNumBtn = false;
              //修改成不可编辑人数
              // orderPlayerList[j].playerNumdisabled = true;
              //行不可新增减少
              orderPlayerList[j].jianBtn = false;
              orderPlayerList[j].jiaBtn = false;
            }
          }
        }
      }
    },
    /**
     * 会员卡-次卡计算实收金额 row:行数据
     */
    setPlayCounts(row) {
      //设置会员收款金额
      if (
          row.cardWallet && row.cardWallet.cardType == 1 &&
          row.cardWallet.benefits.length > 0 &&
          row.cardWallet.benefits[0].exchangeRate !== undefined &&
          row.cardWallet.benefits[0].exchangeRate !== null
      ) {
        //汇率金额
        // const total = Number(row.cardWallet.balanceCny);
        // const playerNum = Number(row.playerNum);
        //
        // const s = (balance, exchangeRate, length) => {
        //   // 先转换为数字
        //   balance = Number(balance);
        //   exchangeRate = Number(exchangeRate);
        //   length = Number(length);
        //
        //   let multiply = exchangeRate * length;
        //
        //   let balanceFen = Math.round(balance * 100);
        //   let multiplyFen = Math.round(multiply * 100);
        //
        //   let diffFen = Math.abs(multiplyFen - balanceFen);
        //
        //   // threshold = 0.01 → 1 分
        //   // if diff > threshold → 返回 balance
        //   if (diffFen > thresholdFen) {
        //     return Math.floor(multiply * 100) / 100; // 返回应扣金额
        //   } else {
        //     return balance; // 返回余额
        //
        //   }
        // }

        // let sPay = JSON.parse(JSON.stringify(s(total, row.cardWallet.benefits[0].exchangeRate, playerNum)))
        row.payAmount = `${row.playerNum}(次)`
        // this.setTotalPayAmount()
      }
    },

    /**
     * 计算实收总额
     */
    setTotalPayAmount() {
      this.formData.data['totalPayAmount'] = 0;
      let routerParam = this.$store.getters.getRouterParam || ''
      //循环计算金额
      let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
      for (let i = 0; i < orderPlayerList.length; i++) {
        // 跳过会员卡次卡的情况：payMode=17 且 cardType=1
        if (orderPlayerList[i].payMode === 17 &&
            orderPlayerList[i].cardWallet &&
            orderPlayerList[i].cardWallet.cardType === 1

        ) {
          continue;
        }

        if (orderPlayerList[i]['payAmount']) {
          //如果实收有特殊字符
          let str = orderPlayerList[i]['payAmount'] + "";
          if (str) {
            if (str.indexOf("(") >= -1) {
              let num = str.split("(")[0];
              //实收总额
              this.formData.data['totalPayAmount'] = this.$tools.accAdd(this.formData.data['totalPayAmount'],
                  num);
            } else {
              //实收总额
              this.formData.data['totalPayAmount'] = this.$tools.accAdd(this.formData.data['totalPayAmount'],
                  orderPlayerList[i]['payAmount']);
            }
          }
        }

        //如果有退款金额,减去实退金额
        if (orderPlayerList[i]['tuiAmount']) {
          this.formData.data['totalPayAmount'] = this.$tools.accSub(this.formData.data['totalPayAmount'],
              orderPlayerList[i]['tuiAmount']);
        }
      }
    },
    /**
     * 提取 Meituan pay amount（直接用 merchantAmount 计算）
     */
    getMeituanPayAmount(item) {
      const dealPrice = Number(item.dealPrice || 0);
      const merchantDiscount = Number(item.merchantAmount || 0);
      return merchantDiscount > 0 ? Math.max(0, dealPrice - merchantDiscount) : dealPrice;
    },
    /**
     * 计算玩家总数和应收
     */
    setPlayerAndPrice() {
      if (this.currTheme && this.formData.data.themePrice) {
        //重置
        this.formData.data['totalPeopleNum'] = 0;
        this.formData.data['totalReceivePrice'] = 0;
        let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
        for (let i = 0; i < orderPlayerList.length; i++) {
          //rowspan>0表示是主要行
          if (orderPlayerList[i].rowspan > 0 && orderPlayerList[i]['playerNum']) {
            //玩家总数
            this.formData.data['totalPeopleNum'] = this.$tools.accAdd(this.formData.data['totalPeopleNum'],
                orderPlayerList[i]['playerNum']);
            //应收金额
            orderPlayerList[i]['shouldPayAmount'] = this.$tools.accMul(orderPlayerList[i]['playerNum'],
                this.formData.data.themePrice);
            //如果有退款人数,减去退款人数
            if (orderPlayerList[i]['playerTuiNum']) {
              //玩家总数
              this.formData.data['totalPeopleNum'] = this.$tools.accSub(this.formData.data['totalPeopleNum'],
                  orderPlayerList[i]['playerTuiNum']);
              //应退金额
              orderPlayerList[i]['shouldTuiAmount'] = this.$tools.accMul(orderPlayerList[i]['playerTuiNum'],
                  this.formData.data.themePrice);
            }
            //应收结算
            this.formData.data['totalReceivePrice'] = this.$tools.accAdd(this.formData.data['totalReceivePrice'],
                orderPlayerList[i]['shouldPayAmount']);
            //如果有退款金额,减去应退金额
            if (orderPlayerList[i]['shouldTuiAmount']) {
              this.formData.data['totalReceivePrice'] = this.$tools.accSub(this.formData.data['totalReceivePrice'],
                  orderPlayerList[i]['shouldTuiAmount']);
            }


            //计算实收
            // this.setTotalPayAmount();
          }
        }
      }
    },
    /**
     * 处理收款金额
     */
    handlePayAmountByRow() {
      if (this.currTheme && this.formData.data.themePrice) {
        //重置
        this.formData.data['totalPeopleNum'] = 0;
        this.formData.data['totalReceivePrice'] = 0;
        let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;
        for (let i = 0; i < orderPlayerList.length; i++) {
          //rowspan>0表示是主要行
          if (orderPlayerList[i].rowspan > 0 && orderPlayerList[i]['playerNum']) {
            //玩家总数
            this.formData.data['totalPeopleNum'] = this.$tools.accAdd(this.formData.data['totalPeopleNum'],
                orderPlayerList[i]['playerNum']);
            //应收金额
            orderPlayerList[i]['shouldPayAmount'] = this.$tools.accMul(orderPlayerList[i]['playerNum'],
                this.formData.data.themePrice);
            //如果有退款人数,减去退款人数
            if (orderPlayerList[i]['playerTuiNum']) {
              //玩家总数
              this.formData.data['totalPeopleNum'] = this.$tools.accSub(this.formData.data['totalPeopleNum'],
                  orderPlayerList[i]['playerTuiNum']);
              //应退金额
              orderPlayerList[i]['shouldTuiAmount'] = this.$tools.accMul(orderPlayerList[i]['playerTuiNum'],
                  this.formData.data.themePrice);
            }
            //应收结算
            this.formData.data['totalReceivePrice'] = this.$tools.accAdd(this.formData.data['totalReceivePrice'],
                orderPlayerList[i]['shouldPayAmount']);
            //如果有退款金额,减去应退金额

            //region 判断金额
            //获取收款行总数
            let count = 0;
            let rowId = orderPlayerList[i].rowId;
            for (let j = 0; j < orderPlayerList.length; j++) {
              if (rowId == orderPlayerList[j].rowId) {
                count++;
              }
            }
            //如果就一行,收款金额实时等于应收金额
            if (count == 1) {
              //不是编辑,不是会员
              if (!orderPlayerList[i].orderPayId && orderPlayerList[i].payMode != 17 && !orderPlayerList[i]['payAmount']) {
                orderPlayerList[i]['payAmount'] = orderPlayerList[i]['shouldPayAmount'];
              }
            }
            //如果多行
            else {
              //剩余金额等于应收金额
              let surplusPayAmount = orderPlayerList[i].shouldPayAmount;
              for (let j = 0; j < orderPlayerList.length; j++) {

                if (rowId == orderPlayerList[j].rowId) {
                  //判断有值
                  if (orderPlayerList[j].payAmount >= 0 && parseFloat(orderPlayerList[j].payAmount) >= 0) {
                    //减去剩余金额
                    surplusPayAmount = this.$tools.accSub(surplusPayAmount, orderPlayerList[j].payAmount);
                  }
                  //没有,设置值
                  else {
                    //设置实收
                    orderPlayerList[j].payAmount = surplusPayAmount;

                    //减去剩余金额
                    surplusPayAmount = this.$tools.accSub(surplusPayAmount, orderPlayerList[j].payAmount);

                  }
                }
              }
            }
            //把金额是负数的统一修改为""
            for (let j = 0; j < orderPlayerList.length; j++) {
              if (parseFloat(orderPlayerList[j].payAmount) < 0) {
                orderPlayerList[j].payAmount = "";
              }
            }
            //endregion
            //计算实收
            // this.setTotalPayAmount();
          }
        }
      }

    },
    //endregion

    //region 设置初始信息

    /**
     *
     * @param orderId 订单id
     * @param type 类型
     * @returns {Promise<unknown>}
     */
    getOrderInfo(orderId) {
      return new Promise((resolve, reject) => {
        this.$POST1("/customer/EomsOrder/findEomsOrderById", {id: orderId}).then(res => {
          //隐藏汇付退款按钮
          // this.$tools.getIndex(this.formData.form, 'button').diy5.show = false
          //先设置场次信息,设置选择主题時需要判断场次是否可选
          this.formData.data.sessionStartTime = res.data.sessionStartTime;
          this.formData.data.sessionEndTime = res.data.sessionEndTime;
          //如果是次日,修改orderCreateTime
          if (res.data.isNextDay) {
            res.data.orderCreateTime =
                this.$dayjs(res.data.orderCreateTime + " 00:00:00").subtract(1, 'day').format("YYYY-MM-DD")
          }
          this.formData.data.orderCreateTime = res.data.orderCreateTime;

          //设置选择的主题
          this.themeRadioChange(res.data.orderGoodsList[0].goodsId).then(e => {
            //设置主题
            res.data.themeName = res.data.orderGoodsList[0].goodsId;
            //设置加班模式
            res.data.orderMode = res.data.orderMode + "";
            //设置来源
            res.data.orderSource = res.data.orderSource ? res.data.orderSource.split(",") : [];
            //设置客群
            res.data.customerType = res.data.customerType ? res.data.customerType.split(",") : [];

            //region 设置岗位
            //循环返回的岗位赋值
            if (res.data.orderGoodsList[0].orderGoodsJobList) {
              let orderGoodsJobList = res.data.orderGoodsList[0].orderGoodsJobList;
              for (let i = 0; i < orderGoodsJobList.length; i++) {
                let arr = [];
                //循环已选择选择的人员
                for (let j = 0; j < orderGoodsJobList[i].orderGoodsJobUserList.length; j++) {
                  arr.push(orderGoodsJobList[i].orderGoodsJobUserList[j].eomsUserId)
                }
                res.data['themeJob_' + orderGoodsJobList[i].jobId] = arr;
              }
            }
            //endregion

            //region 设置场次信息
            for (let i = 0; i < this.currTheme.themeSessionList.length; i++) {
              //确定场次
              if (this.currTheme.themeSessionList[i].startTime == res.data.sessionStartTime
                  && this.currTheme.themeSessionList[i].endTime == res.data.sessionEndTime) {
                //次日
                if (this.currTheme.themeSessionList[i].isTomorrow) {
                  res.data.sessionTime = "次日" + res.data.sessionStartTime + "-" + res.data.sessionEndTime;
                }
                //今日
                else {
                  res.data.sessionTime = res.data.sessionStartTime + "-" + res.data.sessionEndTime;
                }
                //设置主题价格
                res.data.themePrice = this.currTheme.themeSessionList[i].price;
              }
            }
            //endregion

            //region 设置拼场信息
            let orderPlayerList = [];

            if (res.data.orderPlayerList) {
              for (let i = 0; i < res.data.orderPlayerList.length; i++) {
                let rowId = this.$tools.getUUID();
                //  白盒验券扫码  判断是否为最后一条 如果是最后一条证明是白盒扫码后续添加的 需要给boxScan改为true
                let isLast = i === res.data.orderPlayerList.length - 1;
                //设置前几列合并列的数据
                let item = {
                  playerNum: res.data.orderPlayerList[i].playerNum,
                  contactType: res.data.orderPlayerList[i].contactType,
                  note: res.data.orderPlayerList[i].note,
                  shouldPayAmount: '0',
                  //临时数据 区分当前白盒验券生命周期是否结束 如果没结束后续所有验券数据都要添加到当前拼场中
                  boxScan: isLast ? this.yanQuanConfig.visible : false,

                };
                // 如果有收款方式row 进行收款方式row跟拼场row表格合并
                if (res.data.orderPlayerList[i].orderPays.length) {
                  for (let j = 0; j < res.data.orderPlayerList[i].orderPays.length; j++) {
                    //多列的第一行显示合并的信息
                    if (j == 0) {
                      item.payMode = res.data.orderPlayerList[i].orderPays[j].payMode;
                      item.originPayMode = res.data.orderPlayerList[i].orderPays[j].payMode;
                      item.payAmount = res.data.orderPlayerList[i].orderPays[j].payAmount;
                      item.orderPlayerId = res.data.orderPlayerList[i].id;
                      item.orderPayId = res.data.orderPlayerList[i].orderPays[j].id;
                      item.payCoins = res.data.orderPlayerList[i].orderPays[j].payCoins;
                      item.rowId = rowId;
                      item.bspayId = res.data.orderPlayerList[i].orderPays[j].bspayId || null; //汇支付 支付订单id
                      // 只有payMode等于20（小白盒支付）才赋值transStat
                      if (res.data.orderPlayerList[i].orderPays[j].payMode === 20) {
                        item.transStat = res.data.orderPlayerList[i].orderPays[j].transStat || "W"; //汇支付 支付订单状态
                      }
                      //如果有会员信息(会员只能是一列)
                      if (res.data.orderPlayerList[i].orderPays[j].cardWallet) {
                        item.cardWallet = res.data.orderPlayerList[i].orderPays[j].cardWallet;
                        item.customerInfo = res.data.orderPlayerList[i].orderPays[j].cardWallet.vipUserName
                            + "(" + res.data.orderPlayerList[i].orderPays[j].cardWallet.vipPhone + ")"
                            + res.data.orderPlayerList[i].orderPays[j].cardWallet.cardName;
                        //次卡会员拼接次数
                        if (item.cardWallet && item.cardWallet.cardType == 1) {
                          item.payAmount = `${item.payCoins}(次)`
                          item.MaximumUsageCount = parseFloat(item.payAmount) + Number(item.cardWallet.balance)
                        }
                      }
                      orderPlayerList.push(item);
                    }
                    //其他列不设置合并的信息,设置会导致合计错误
                    else {
                      let temp = {
                        payMode: res.data.orderPlayerList[i].orderPays[j].payMode,
                        originPayMode: res.data.orderPlayerList[i].orderPays[j].payMode,
                        payAmount: res.data.orderPlayerList[i].orderPays[j].payAmount,
                        orderPlayerId: res.data.orderPlayerList[i].id,
                        orderPayId: res.data.orderPlayerList[i].orderPays[j].id,
                        rowId: rowId,
                        bspayId: res.data.orderPlayerList[i].orderPays[j].bspayId || null, //汇支付 支付订单id
                        transStat: res.data.orderPlayerList[i].orderPays[j].transStat || null, //汇支付 支付订单状态
                      };
                      orderPlayerList.push(temp)
                    }
                  }
                } else {
                  // 没有收款方式rou 直接渲染空拼场row
                  item.rowId = rowId;
                  orderPlayerList.push(item);
                }

              }

              let isHuiyuan = 0;
              for (let i = 0; i < res.data.orderPlayerList.length; i++) {
                for (let j = 0; j < res.data.orderPlayerList[i].orderPays.length; j++) {
                  if (res.data.orderPlayerList[i].orderPays[j].payMode == 17) {
                    isHuiyuan++;
                  }
                }

              }
              //有会员信息设置切换主题,日期,场次不可用
              if (isHuiyuan > 0) {
                this.$tools.getIndex(this.formData.form, 'themeName').disabled = true;
                this.$tools.getIndex(this.formData.form, 'orderCreateTime').disabled = true;
                this.$tools.getIndex(this.formData.form, 'sessionTime').disabled = true;
              }
            }
            //把处理好的数据给到table, 这里table的数据与赋值的原数据是分开的
            this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data = orderPlayerList;

            //endregion


            //region 设置退款信息
            if (res.data.refunds && res.data.refunds.length > 0) {

              //有退款,显示退款的数据
              this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.column.forEach(col => {
                if (col.prop === 'playerTuiNum' || col.prop === 'tuiAmountStr') {
                  col.show = true;
                }
              });
              this.columnCount = 5;

              let refunds = res.data.refunds;
              let orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data;

              //region 拼场信息
              for (let i = 0; i < orderPlayerList.length; i++) {
                orderPlayerList[i].playerTuiNum = 0;
                for (let j = 0; j < refunds.length; j++) {
                  let players = refunds[j].players;
                  for (let k = 0; k < players.length; k++) {
                    //判断同一列的同时 判断是否有人数,有人数就是合并行,没有人数是被合并行
                    if (players[k].orderPlayerId == orderPlayerList[i].orderPlayerId && orderPlayerList[i].playerNum) {
                      orderPlayerList[i].playerTuiNum = this.$tools.accAdd(orderPlayerList[i].playerTuiNum,
                          players[k].playerNum)
                    }
                  }
                }
                //如果退款人数大于0,这一列不可操作
                if (orderPlayerList[i].playerTuiNum > 0) {
                  orderPlayerList[i].playerNumdisabled = true;
                }
              }
              //endregion

              //region 收款信息
              //把所有退款整合到一个集合
              let paysAll = [];
              for (let j = 0; j < refunds.length; j++) {
                for (let k = 0; k < refunds[j].pays.length; k++) {
                  paysAll.push(refunds[j].pays[k])
                }
              }
              //循环匹配给收款信息
              for (let i = 0; i < orderPlayerList.length; i++) {
                //默认退款信息
                orderPlayerList[i].tuiAmountStr = "";
                orderPlayerList[i].tuiAmount = 0;
                //循环匹配
                for (let k = 0; k < paysAll.length; k++) {
                  if (paysAll[k].orderPayId == orderPlayerList[i].orderPayId) {
                    //拼接退款信息
                    if (orderPlayerList[i].tuiAmountStr) {
                      orderPlayerList[i].tuiAmountStr += (", " + paysAll[k].payModeStr + "(" + paysAll[k].payAmount + "元)")
                    } else {
                      orderPlayerList[i].tuiAmountStr = paysAll[k].payModeStr + "(" + paysAll[k].payAmount + "元)"
                    }
                    //设置退款金额(用于计算结算金额的)
                    orderPlayerList[i].tuiAmount = this.$tools.accAdd(orderPlayerList[i].tuiAmount, paysAll[k].payAmount);
                  }
                }
              }
              //endregion

              //有退款信息设置切换主题,日期,场次不可用
              this.$tools.getIndex(this.formData.form, "themeName").disabled = true;
              this.$tools.getIndex(this.formData.form, "orderCreateTime").disabled = true;
              this.$tools.getIndex(this.formData.form, "sessionTime").disabled = true;

              //设置按钮
              this.setTable();

            }
            //endregion

            //region 设置差额说明
            const notices = JSON.parse(res.data.orderPriceDiffNoticesJsonStr || '[]')
            if (notices.length > 0) {
              this.orderPriceDiffNoticesInput = notices[notices.length - 1].value  // 最后一项的 value
              this.checkedTypes = notices.slice(0, -1).map(item => ({id: item.id, value: item.value}));
            } else {
              this.orderPriceDiffNoticesInput = ''
              this.checkedTypes = []
            }
            //endregion

            //region 设置极迅小白盒验券信息
            if (res.data.orderVerifyList.length) {
              this.$tools.getIndex(this.formData.form, "orderVerifyList").tableData.data = this.handleOrderVerifyList(res.data.orderVerifyList, {  })
            }
            //region 设置优惠券验券信息（playerCouponList）
            if (res.data.playerCouponList && res.data.playerCouponList.length) {
              this.$tools.getIndex(this.formData.form, "playerCouponList").tableData.data = this.handlePlayerCouponList(res.data.playerCouponList)
            }
            //endregion

            //表单赋值
            this.formData.data = res.data;
            //如果开启差额提示 初始化数据时候添加
            if (this.shopDiffPriceNoticeType) {
              this.formData.data['orderPriceDiffs'] = this.shopDiffPriceNoticeType;
            }
            //计算,设置orderPlayerList后,合并行需要时间,这里延迟等待orderPlayerList合并完毕
            setTimeout(res => {
              this.setPlayerAndPrice();
              //计算收款金额
              this.handlePayAmountByRow()
              //设置收款金额
              this.setTotalPayAmount();
              this.setTable();
              resolve(this.formData.data);
            }, 100)

          })

        }).catch(err=>{
           this.$tools.handleOrderUpdateException(err, {
            onBack: () => this.btnClick("back"),
          })
        });
      })
    },


    /**
     * 处理美团数据验券数据
     */
    handleOrderVerifyList(orderVerifyList1, options = {}) {
      this.$tools.getIndex(this.formData.form, 'baiheCodeTitle').show = true;
      this.$tools.getIndex(this.formData.form, 'orderVerifyList').show = true;

      const safeList = Array.isArray(orderVerifyList1) ? orderVerifyList1 : [];
      const amountTypeMap = {
        2: '抵用券',
        5: '积分',
        6: '立减',
        8: '商户抵用券',
        10: 'C端美团支付',
        12: '优惠代码',
        15: '美团立减',
        17: '商家立减',
        18: '美团商家立减',
        21: '次卡',
        22: '打折卡',
        23: 'B端美团支付',
        24: '全渠道会员券',
        25: 'pos支付',
        26: '线下认款平台',
        28: '商家折上折',
        29: '美团分销支付'
      };

      safeList.forEach(item => {
        item.couponPayAmount = '-';
        item.html = '-';
        item.columnPopover = '';

        if (!item.meituanConsume && !item.douyinConsume) {
          return;
        }
        if (item.meituanConsume && item.meituanConsume.responseStr) {
          try {
            const consumeData = JSON.parse(item.meituanConsume.responseStr || '{}');
            const paymentDetails = Array.isArray(consumeData.paymentDetail) ? consumeData.paymentDetail : [];
            const dealPrice = Number(consumeData.dealPrice || 0);
            const merchantDiscount = Number(consumeData.merchantAmount || 0);

            const finalDealPrice = merchantDiscount > 0
                ? Math.max(0, dealPrice - merchantDiscount)
                : dealPrice;

            const displayPaymentDetails = paymentDetails
                .map(detail => ({
                  ...detail,
                  amount: Number(detail.amount || 0),
                  amountType: Number(detail.amountType),
                  amountTypeText: amountTypeMap[Number(detail.amountType)] || String(detail.amount || ''),
                }))
                .filter(detail => detail.amount > 0);

            const formatYuan = value => {
              if (value === undefined || value === null || value === '') {
                return null;
              }
              const normalized = `${value}`.trim();
              if (normalized === '' || Number.isNaN(Number(normalized))) {
                return null;
              }
              return `￥${Number(normalized).toFixed(2)}`;
            };

            const detailRows = [];
            if (merchantDiscount > 0) {
              detailRows.push({
                label: amountTypeMap[17] || '商家立减',
                value: `- ${formatYuan(merchantDiscount)}`,
                type: 'discount'
              });
            }

            item.finalDealPrice = finalDealPrice;
            item.couponPayAmount = Number(finalDealPrice).toFixed(2);
            item.paymentDetails = displayPaymentDetails;
            item.goodsName = `${item.goodsName}[${dealPrice.toFixed(2)}元]`
            item.html = detailRows.length
                ? `
                <div class="discount-amount-card">
                  ${detailRows.map(row => `
                    <div class="discount-amount-row">
                      <span class="discount-amount-label">${row.label}</span>
                      <span class="discount-amount-value ${row.type}">${row.value}</span>
                    </div>
                  `).join('')}
                </div>
              `
                : '-';

            return;
          } catch (e) {
            console.error('美团验券解析异常', e);
            item.html = '美团验券数据解析错误';
            item.couponPayAmount = '-';
            return;
          }
        }

        if (item.douyinConsume && item.douyinConsume.responseStr) {
          try {
            const douyinData = JSON.parse(item.douyinConsume.responseStr || '{}');
            console.log('responseStr',douyinData)
            const amountObj = douyinData.amount || {};

            item.couponPayAmount = this.$tools.accMul( this.$tools.accAdd(amountObj.coupon_pay_amount || 0, amountObj.platform_discount_amount || 0), 0.01).toFixed(2);
            // 抖音优惠信息也只展示一次，保持和美团一致
            const detailRows = [];
            const formatYuan = value => {
              if (value === undefined || value === null || value === '') {
                return null;
              }
              const normalized = `${value}`.trim();
              if (normalized === '' || Number.isNaN(Number(normalized))) {
                return null;
              }
              return `￥${this.$tools.accMul(normalized, 0.01)}`;
            };

            const discountPrice = formatYuan(amountObj.payment_discount_amount);
            if (discountPrice) {
              detailRows.push({ label: '支付优惠', value: `- ${discountPrice}`, type: 'discount' });
            }
            item.goodsName = `${item.goodsName}[${item.couponPayAmount}元]`
            item.receiptCode = item.douyinConsume.receiptCode || item.receiptCode;
            // item.html = detailRows.length
            //   ? `
            //     <div class="discount-amount-card">
            //       ${detailRows.map(row => `
            //         <div class="discount-amount-row">
            //           <span class="discount-amount-label">${row.label}</span>
            //           <span class="discount-amount-value ${row.type}">${row.value}</span>
            //         </div>
            //       `).join('')}
            //     </div>
            //   `
            //   : '-';
            item.html = '-';
            return;
          } catch (e) {
            item.html = '抖音验券数据解析错误';
            item.couponPayAmount = '-';
            return;
          }
        }

      });

      return safeList;
    },
    /**
     * 处理优惠券验券数据（独立表格 playerCouponList）
     * - 如果有数据，显示 couponCodeTitle 和 playerCouponList
     * - 返回格式化后的数组，包含 goodsName, receiptCode, price, verifyTime
     */
    handlePlayerCouponList(playerCouponList) {
      // 容错：确保是数组
      if (!Array.isArray(playerCouponList) || playerCouponList.length === 0) {
        try {
          this.$tools.getIndex(this.formData.form, 'couponCodeTitle').show = false;
          this.$tools.getIndex(this.formData.form, 'playerCouponList').show = false;
        } catch (e) {
          // 忽略获取失败
        }
        return [];
      }

      // 确保显示表格
      try {
        this.$tools.getIndex(this.formData.form, 'couponCodeTitle').show = true;
        this.$tools.getIndex(this.formData.form, 'playerCouponList').show = true;
      } catch (e) {
        // 忽略
      }

      // 格式化每一条记录以符合 tableData.column 的字段
      return playerCouponList.map(raw => {
        const item = raw || {};
        const goodsName = `${item.playerName}(${item.playerPhone})`;
        const receiptCode = item.numberStr || '';
        // price 可能已经是数字或字符串，确保为数字并保留两位
        const priceNum = Number(item.price);
        const price = Number.isFinite(priceNum) ? priceNum.toFixed(2) : (item.price ? String(item.price) : '0.00');

        // 优先 useTime -> validTime -> use_time-like fields -> validateEndTime -> validateStartTime
        const timeCandidates = [item.useTime, item.validTime, item.valid_time, item.use_time, item.validateEndTime, item.validateStartTime];
        let verifyTime = '-';
        for (let t of timeCandidates) {
          if (t) {
            try {
              const s = this.$dayjs(t);
              if (s && s.isValid && s.isValid()) {
                verifyTime = s.format('YYYY-MM-DD HH:mm:ss');
              } else {
                verifyTime = String(t);
              }
            } catch (e) {
              verifyTime = String(t);
            }
            break;
          }
        }

        return {
          goodsName,
          receiptCode,
          price,
          verifyTime,
          _raw: item
        };
      });
    },

    /**
     * 初始化表单数据
     */
    initFormData() {
      //清空主题
      this.currTheme = null;
      //清空场次
      this.$tools.getIndex(this.formData.form, 'sessionTime').sourceList = [];
      //重置数据
      this.formData.data = {
        orderCreateTime: this.$dayjs().format("YYYY-MM-DD"),
        tags: '1',
        codeList: [],
        orderPriceDiffs: this.shopDiffPriceNoticeType
      };
      this.columnCount = 4;
      //初始环拼场信息Table的数据
      this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data = [{
        playerNum: '',
        contactType: '',
        note: '',
        shouldPayAmount: '0',
        payMode: '',
        payAmount: '',
        jianBtn: false,        //第一行收款行不能删除
        payBtn: false,         //默认都不展示 支付按钮 只有汇付收款方式才会展示 “支付按钮”
        rowId: this.$tools.getUUID(),  //行ID,用于区分是拼场的行还是收款的行
      }];
    },

    /**
     * 初始化页面基本参数
     */
    initBasicParam() {
      return new Promise((resolve, reject) => {
        //已存在则直接返回
        if (isInit) {
          resolve();
          return;
        }
        isInit = true;

        //请求所有参数
        Promise.all([
          //查询系统参数
          this.$POST("/customer/EomsShopSysValue/page/np", {
            shopId: this.$store.state.shopInfo.id,
            size: 999,
            current: 0
          }),
          //查询主题
          this.$POST("/customer/EomsTheme/selectEomsTheme", {shopId: this.$store.state.shopInfo.id}),
          //查询员工,选择岗位用
          this.$POST("/customer/EomsShopUser/selectEomsShopUserByCondition", {shopId: this.$store.state.shopInfo.id}),
          //查询收款方式
          this.$GET("/customer/EomsShopReceiveMode/getReceiveModes?shopId=" + this.$store.state.shopInfo.id),
          //查询客群来源模式
          this.$POST("/customer/EomsShopState/getShopStateList", {shopId: this.$store.state.shopInfo.id}),
          this.$POST("/customer/EomsShop/shop/diff/price/notice", {
            shopId: this.$store.state.shopInfo.id,
            current: 1,
            size: 20
          }),
        ]).then(res => {

          //region 处理数据
          //处理系统参数
          if (res && res[0] && res[0].data) {
            this.$tools.getIndex(this.formData.form, 'orderSource').sourceList = [];
            for (let i = 0; i < res[0].data.orderSources.length; i++) {
              this.$tools.getIndex(this.formData.form, 'orderSource').sourceList.push(res[0].data.orderSources[i]);
            }
            this.$tools.getIndex(this.formData.form, 'customerType').sourceList = [];
            for (let i = 0; i < res[0].data.customerTypes.length; i++) {
              this.$tools.getIndex(this.formData.form, 'customerType').sourceList.push(res[0].data.customerTypes[i]);
            }
          }
          //处理主题
          if (res && res[1] && res[1].data) {
            this.$tools.getIndex(this.formData.form, 'themeName').sourceList = res[1].data.themeList
          }
          //处理员工
          if (res && res[2] && res[2].data) {
            this.shopStaffList = res[2].data
          }
          //处理收款方式
          if (res && res[3] && res[3].data) {
            this.$tools.getIndex(this.$tools.getIndex(this.formData.form, 'orderPlayerList')
                .tableData.column, 'payMode').sourceList = [];
            for (let i = 0; i < res[3].data.length; i++) {
              this.$tools.getIndex(this.$tools.getIndex(this.formData.form, 'orderPlayerList').tableData.column, 'payMode').sourceList.push(res[3].data[i]);
            }
          }
          //处理客群来源模式
          if (res && res[4] && res[4].data) {
            let typeSourceMode = 0;
            for (let i = 0; i < res[4].data.length; i++) {
              if (res[4].data[i].shopStateKey == "ORDER_SOURCE_COLLECT_BTN_KEY") {
                typeSourceMode = res[4].data[i].shopStateValue
              }
              //差额说明开关
              if (res[4].data[i].shopStateKey == "ENABLE_ORDER_PRICE_DIFF_NOTICE") {
                this.shopDiffPriceNoticeType = res[4].data[i].shopStateValue
              }
            }
            //商家填写
            if (typeSourceMode == 1) {
              this.$tools.getIndex(this.formData.form, 'customerType').show = true;
              this.$tools.getIndex(this.formData.form, 'orderSource').show = true;
            }
            //玩家填写
            else {
              this.$tools.getIndex(this.formData.form, 'customerType').show = false;
              this.$tools.getIndex(this.formData.form, 'orderSource').show = false;
            }
          }
          if (res && res[5] && res[5].data) {
            this.shopDiffPriceNoticeList = res[5].data.records
          }
          //endregion

          resolve();
        })

      })
    },

    /**
     * 初始化路由传递参数
     */
    initRouterParam() {
      let routerParam = this.$store.getters.getRouterParam;

      //设置返回路由
      this.sourRouter = routerParam && routerParam.sourRouter ? routerParam.sourRouter : "themeOrder";
      //设置标题
      this.$tools.setTabTitle("新建订单");
      //region 抖音/美团验券新建
      if (routerParam && routerParam.type == "verifyCodeAdd") {
        this.$tools.getIndex(this.formData.form, 'baiheCodeTitle').show = true;
        this.$tools.getIndex(this.formData.form, 'orderVerifyList').show = true;
        //赋值表单信息
        this.$tools.getIndex(this.formData.form, "orderVerifyList").tableData.data = this.handleOrderVerifyList(routerParam.verifyCodeArr, {  })
        console.log('routerParam.verifyCodeArr',routerParam.verifyCodeArr)
      } else {
        //默认不显示验券
        this.$tools.getIndex(this.formData.form, 'baiheCodeTitle').show = false;
        this.$tools.getIndex(this.formData.form, 'orderVerifyList').show = false;
      }
      //endregion
      //region 房间/排场新建,自动选中主题
      if (routerParam && routerParam.type == "homeAdd") {
        this.formData.data.themeName = parseInt(routerParam.themeId);
        this.themeRadioChange(routerParam.themeId, routerParam.timeJson);
      }
      //endregion

      //region 编辑订单
      if (routerParam && routerParam.type == "orderEdit") {
        //设置标题
        this.$tools.setTabTitle("编辑订单");
        //获取订单信息
        this.getOrderInfo(routerParam.orderId);
      }
      //endregion

      //region 转场新建
      if (routerParam && routerParam.type == "orderPlayerAdd") {
        //设置转场信息
        this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data = [];

        for (let i = 0; i < routerParam.orderPlayerTableData.length; i++) {
          this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data.push({
            contactType: routerParam.orderPlayerTableData[i].contactType,
            note: routerParam.orderPlayerTableData[i].note,
            playerNum: routerParam.orderPlayerTableData[i].playerNum,
            rowId: routerParam.orderPlayerTableData[i].rowId,
            rowspan: routerParam.orderPlayerTableData[i].rowspan,
            payMode: "",
            payAmount: "",
          })
        }
        //设置表格
        this.setTable()
      }
      //endregion

      //region 转场编辑
      if (routerParam && routerParam.type == "orderPlayerEdit") {
        //设置标题
        this.$tools.setTabTitle("编辑订单");
        //获取订单信息
        this.getOrderInfo(routerParam.orderId).then(e => {
          //拼场信息Table的数据添加转场数据
          for (let i = 0; i < routerParam.orderPlayerTableData.length; i++) {
            this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data.push({
              contactType: routerParam.orderPlayerTableData[i].contactType,
              note: routerParam.orderPlayerTableData[i].note,
              playerNum: routerParam.orderPlayerTableData[i].playerNum,
              rowId: routerParam.orderPlayerTableData[i].rowId,
              rowspan: routerParam.orderPlayerTableData[i].rowspan,
              payMode: "",
              payAmount: "",
            })
          }
          //重新计算价格
          this.setPlayerAndPrice();
          //计算收款金额
          this.handlePayAmountByRow()
          this.setTotalPayAmount();
        });

      }
      //endregion

    },
    // 保存支付信息到本地缓存并启动扫描
    savePayInfoAndStartScan(orderId, orderCode) {
      //延迟调用
      setTimeout(() => {
        localStorage.setItem('payInfo', JSON.stringify({
          orderId: orderId,//订单id
          bsPayId: this.payRow.bspayId,
          payMode: this.payRow.payMode,
          orderCode,//当时付款的条形码
          timestamp: Date.now(), // 添加时间戳用于过期检查
          themeName: this.formData.data.themeName,
        }));
        this.$refs.scanBox.startCountdown();
        this.$refs.scanBox.startPolling();
      }, 100)
    },

    // 清除临时支付信息缓存
    clearPayInfo() {
      localStorage.removeItem('payInfo');
    },
    resetPayDialogState() {
      this.showBox = false;
      this.status = '';
      this.isClosePay = false;
      this.payRow = {};
      if (this.$refs.scanBox) {
        this.$refs.scanBox.clearTimers();
      }
    },
    closeOrderUpdateDialogs() {
      this.resetPayDialogState();
      if (this.yanQuanConfig) {
        this.yanQuanConfig.visible = false;
        this.yanQuanConfig.status = 'waiting';
        this.yanQuanConfig.value = 1;
        this.yanQuanConfig.verifyCodeArr = [];
        this.yanQuanConfig.payAmount = 0;
        this.yanQuanConfig.peopleNum = '';
      }
      this.yanQuanChecking = false;
      this.clearYanQuanFlowId();
      if (this.$refs.yanQuanScanBox) {
        this.$refs.yanQuanScanBox.goStage(1);
      }
    },
    isPayRestoreRoute() {
      const routerParam = this.$store.getters.getRouterParam || {};
      const editTypes = ['orderEdit', 'orderPlayerEdit'];
      return editTypes.includes(routerParam.type) || (this.$route && ['themeOrderEdit', 'themeOrderAdd'].includes(this.$route.name));
    },
    getRestoreTargetOrderId() {
      const routerParam = this.$store.getters.getRouterParam || {};
      const formData = this.formData || {};
      const formState = formData.data || {};
      return formState.id || routerParam.orderId || '';
    },
    findPendingPayRow(bsPayId, payMode) {
      const orderPlayerList = this.$tools.getIndex(this.formData.form, "orderPlayerList").tableData.data || [];
      return orderPlayerList.find(item =>
          item.payMode === payMode &&
          item.bspayId === bsPayId &&
          ['W', 'P'].includes(item.transStat)
      );
    },
    applyRestorePaySession(payRow) {
      this.payRow = payRow || {};
      this.showBox = true;
      this.isClosePay = true;
      this.status = 'P';

      const orderPlayerColumn = this.$tools.getIndex(
          this.formData.form,
          "orderPlayerList"
      ).tableData.column;

      if (orderPlayerColumn) {
        const transStatColumn = this.$tools.getIndex(orderPlayerColumn, "transStat");
        if (transStatColumn) {
          transStatColumn.show = true;
        }
      }

      this.$nextTick(() => {
        if (this.$refs.scanBox) {
          this.$refs.scanBox.startCountdown();
          this.$refs.scanBox.startPolling();
          console.log('pay session restored');
        }
      });
    },
    // 检查并恢复本地缓存的支付信息
    checkAndRestorePayInfo() {
      const payInfoStr = localStorage.getItem('payInfo');
      if (!payInfoStr) return;

      const routerParam = this.$store.getters.getRouterParam || {};
      const hasRouterParam = !!routerParam && Object.keys(routerParam).length > 0;
      const isEditRoute = this.isPayRestoreRoute();

      if (hasRouterParam && !isEditRoute) {
        if (routerParam.type === 'themeOrderAdd') {
          this.initBasicParam().then(() => {
            this.initFormData();
          });
        }
        this.resetPayDialogState();
        this.clearPayInfo();
        return;
      }

      if (!isEditRoute) {
        this.resetPayDialogState();
        return;
      }

      let payInfo;
      try {
        payInfo = JSON.parse(payInfoStr);
      } catch (error) {
        this.clearPayInfo();
        return;
      }

      const {orderId, bsPayId, payMode, orderCode, timestamp, themeName} = payInfo;
      if (!orderId || !bsPayId || !payMode || !orderCode || !themeName) {
        console.log('pay info is incomplete, clear cache');
        this.clearPayInfo();
        return;
      }

      const EXPIRE_TIME = 5 * 60 * 1000;
      if (!timestamp || Date.now() - timestamp > EXPIRE_TIME) {
        console.log('pay info expired, clear cache');
        this.clearPayInfo();
        return;
      }

      if (this.showBox && this.status === 'P') {
        console.log('pay session already exists, skip restore');
        return;
      }

      const targetOrderId = this.getRestoreTargetOrderId();
      const isAddRoute = this.$route && this.$route.name === 'themeOrderAdd';
      if (!isAddRoute && (!targetOrderId || String(targetOrderId) !== String(orderId))) {
        console.log('restore order mismatch, clear cache');
        this.clearPayInfo();
        return;
      }

      this.statusCheckController = new AbortController();
      this.$POST(
          '/customer/bsorder/trade/payment/micropay/result',
          {bsPayId, payMode},
          false,
          false,
          {signal: this.statusCheckController.signal}
      )
          .then(res => {
            if (res.code !== 200) {
              this.clearPayInfo();
              return;
            }

            const transStat = res.data.trans_stat;
            console.log('pay status:', transStat);

            if (transStat !== 'P') {
              this.clearPayInfo();
              if (transStat === 'S' || transStat === 'F') {
                this.getOrderInfo(orderId);
              }
              return;
            }

            this.restorePaymentSession(orderId, bsPayId, payMode, orderCode);
          })
          .catch(err => {
            if (err.name === 'AbortError' || err.name === 'CanceledError') return;
            console.error('pay status query failed', err);
            this.clearPayInfo();
          });
    },

    // restore pay session
    restorePaymentSession(orderId, bsPayId, payMode, orderCode) {
      if (!this.formData.form || !this.$refs.scanBox) {
        console.log('scan box not ready, retry in 800ms');
        if (this.restoreTimer) {
          clearTimeout(this.restoreTimer);
        }

        this.restoreTimer = setTimeout(() => {
          if (!this.$refs.scanBox) {
            console.log('scan box still unavailable, clear cache');
            this.clearPayInfo();
            return;
          }
          this.restorePaymentSession(orderId, bsPayId, payMode, orderCode);
        }, 800);
        return;
      }

      this.getOrderInfo(orderId)
          .then(() => {
            const matchedPayRow = this.findPendingPayRow(bsPayId, payMode);
            if (matchedPayRow) {
              this.applyRestorePaySession(matchedPayRow);
              return;
            }

            this.applyRestorePaySession({
              bspayId: bsPayId,
              payMode: payMode,
              authCode: orderCode,
              transStat: 'P'
            });
          })
          .catch(err => {
            console.error('get order info failed', err);
            this.applyRestorePaySession({
              bspayId: bsPayId,
              payMode: payMode,
              authCode: orderCode,
              transStat: 'P'
            });
          });
    },


  },
  mounted() {
    isInit = false;
    this.initBasicParam().then(res => {
      // 初始化数据
      this.initFormData();
      // 初始化路由传递参数
      this.initRouterParam();
      // 仅在编辑或刷新场景尝试恢复支付会话
      this.$nextTick(() => {
        this.checkAndRestorePayInfo();
      });
    });
  }
  ,
  beforeUnmount() {
    this.setYanQuanBusinessBusy(false);
    this.scheduleYanQuanLogFlush(0);
  },

  deactivated() {
    this.setYanQuanBusinessBusy(false);
    this.scheduleYanQuanLogFlush(0);
  },

  activated() {
    this.initBasicParam().then(res => {
      // 初始化路由传递参数
      this.initRouterParam();
      // 仅在编辑或刷新场景尝试恢复支付会话
      this.$nextTick(() => {
        this.checkAndRestorePayInfo();
      });
    });
  }
}
</script>

<style>
.pay-message {
  z-index: 9999 !important;
}

.el-message.pay-message {
  z-index: 9999 !important;
}

.my-message-box {
  width: auto !important;
  --el-messagebox-width: auto !important;
}

.refund-summary-box .el-message-box__content .el-message-box__container {
  display: block;
}

.discount-amount-card {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  border-left-width: 4px;
  border-left-color: rgba(220, 38, 38, 0.8);
  background: rgba(244, 246, 248, 0.4);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
  min-height: 24px;
}

.discount-amount-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 2px 5px;
}

.discount-amount-label {
  color: #475569;
  font-size: 12px;
}

.discount-amount-value {
  font-weight: 600;
  font-size: 12px;
  color: #dc2626;
}

.discount-amount-value.accent,
.discount-amount-value.discount {
  color: #dc2626;
}
</style>
